<template>
    <div id="fssContractAdd">
        <van-steps class="step" @click-step="item => {if(activeMax>item || activeMax == item){active = item}}" :active="active" active-color="#FD7E2D">
            <van-step>基础信息</van-step>
            <van-step>租期信息</van-step>
            <van-step>资产信息</van-step>
            <van-step>附件信息</van-step>
            <van-step v-if="form.tenantType != 2">施工宝</van-step>
        </van-steps>
        <!-- 第一步 -->
        <div v-if="active === 0" class="form1">
            <van-form ref="form1" label-width="110px" input-align="right">
                <van-field readonly :clickable="!disable.house" required :disabled="disable.house" name="house" :value="houseNow.address" label="房源" placeholder="点击搜索房源>" @click="item => { if(!disable.house){showHouse = true;searchValueHouse='';} }" :rules="[{ required: true, message: '请选择房源' }]" />
                <van-field name="tenantType" label="承租" required :rules="[{ validator :validTenantType, message: '请选择预定方式' }]">
                    <template #input v-if="active === 0">
                        <van-radio-group :value="form.tenantType" :disabled="Boolean(form.prevId)" direction="horizontal">
                            <van-radio :name="1" @click="changeTenantType(1)">包租</van-radio>
                            <van-radio :name="2" @click="changeTenantType(2)">托管</van-radio>
                              <van-radio :name="3" @click="changeTenantType(3)">托管+</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field readonly :clickable="!Boolean(form.prevId)" required :disabled="Boolean(form.prevId)" name="业主手机号" :value="form.propertyPhone" label="业主手机号" placeholder="点击搜索业主>" @click="item => { if(!Boolean(form.prevId)){showProperty = true;searchValueProperty='';propertyList=[]} }" maxlength="11" :rules="[{ required: true, message: '请填写手机号' },{ validator :validPhone, message: '请输入正确手机号' }]" />
                <van-field :clickable="!Boolean(form.prevId)" required :disabled="Boolean(form.prevId)" v-model="form.propertyName" name="name" label="姓名" placeholder="点击填写" :rules="[{ required : true, message: '请填写姓名' }]" />
                <van-field readonly :clickable="!Boolean(form.prevId)" required :disabled="Boolean(form.prevId)" name="idType" :value="idTypeList[form.idType-1]" label="证件类型" placeholder="点击选择>" @click="item => {if(!Boolean(form.prevId)){ showIdType = true} }" :rules="[{ required: true, message: '请选择证件类型' }]" />
                <van-field type="text" :clickable="!Boolean(form.prevId)" required :disabled="Boolean(form.prevId)" v-model="form.idNo" name="idNo" label="证件号码" placeholder="点击填写" :rules="[{ required: true, message: '请填写证件号码' },{ validator :validIdNo1, message: '请输入正确的身份证' }]" />
                <van-field :clickable="!Boolean(form.prevId)"   clearable v-model="form.contactName" name="contactName" label="紧急联系人姓名" placeholder="点击填写" />
                <van-field readonly clearable @click-right-icon.stop="clearContactRelation" right-icon="close" :clickable="!Boolean(form.prevId)"  name="contactRelation" :value="contactList[form.contactRelation-1]" label="紧急联系人关系" placeholder="点击选择>" @click="item => { showContact = true }" >
                    <!-- <template #button>
                        <van-button @click.stop="clearContactRelation" size="mini" type="primary">清除</van-button>
                    </template> -->
                </van-field>
                <van-field v-model="form.contactPhone" clearable :clickable="!Boolean(form.prevId)"  type="tel" name="contactPhone" label="紧急联系人电话" placeholder="点击填写" maxlength="11" :rules="[{ validator :validPhone, message: '请输入正确手机号' },{validator:item=>{ return Boolean(form.contactPhone != form.propertyPhone) },message:'紧急联系人电话不可与业主相同'}]" />
                <van-field label="收款">
                    <template #input v-if="active === 0">
                        <van-radio-group v-model="accountType" direction="horizontal" @change="changeAccount">
                            <van-radio :name="1">选择已有</van-radio>
                            <van-radio :name="2">新增</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field readonly clickable required name="payType" :value="payTypeList[this.form.payType-1]" label="支付方式" placeholder="点击选择>" @click="showPayType = true" :rules="[{ required: true, message: '请选择支付方式' }]" />
                <van-field v-if="form.payType&&form.propertyId&&accountType==1" required readonly clickable name="bankAccount" :value="form.bankAccount" label="收款账号" placeholder="点击选择>" @click="showReceipt = true;getReceiptList()" maxlength="11" :rules="[{ required: true, message: '请填写收款账号' }]" />
                <van-field v-if="form.payType&&form.propertyId&&accountType==2" required name="bankAccount" v-model="form.bankAccount" label="收款账号" placeholder="点击填写" :rules="[{ required: true, message: '请填写收款账号' }]" />
                <van-field v-if="form.payType&&form.propertyId" required v-model="form.accountName" name="accountName" label="收款人姓名" placeholder="点击填写" :rules="[{ required: true, message: '请填写姓名' }]" />
                <van-field v-if="(form.payType == 3 || form.payType == 4)&&form.propertyId" required readonly clickable :value="form.bankName" name="bankName" label="开户行" placeholder="点击选择>" @click="showBank = true;getBankList()" :rules="[{ required: true, message: '请填写开户行' }]" />
                <van-field v-if="(form.payType == 3 || form.payType == 4)&&form.propertyId" required v-model="form.bankBranchName" name="bankBranchName" label="支行名称" placeholder="点击填写" :rules="[{ required: true, message: '请填写支行名称' }]" />
            </van-form>
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" @click="next1" :disabled="saveLoad" :loading="saveLoad">下一步</van-button>
            </div>
        </div>
        <!-- 第二步 -->
        <div v-if="active === 1" class="form2">
            <van-form ref="form2" label-width="110px" input-align="right">
                <van-field readonly clickable required name="makeDate" :value="form.makeDate?form.makeDate.slice(0,10):''" label="交房日期" placeholder="点击选择日期>" @click=" item => { showMakeDate = true } " :rules="[{ required: true, message: '请选择日期' }]" />
                <!-- 包租 -->
                <div v-if="form.tenantType != 2">
                    <van-field readonly :clickable="!form.prevId" :disabled="Boolean(form.prevId)" required name="activeDate" :value="form.activeDate?form.activeDate.slice(0,10):''" label="生效日期" placeholder="点击选择日期>" @click=" item => { if(!form.prevId){showActiveDate = true} } " :rules="[{ required: true, message: '请选择日期' },{ validator: item => { return Boolean(form.activeDate >= form.makeDate) }, message: '生效日期不能小于交房日期' }]" />
                    <van-field readonly clickable required name="freeType" :value="freeTypeList[form.freeType-1]" label="免租方式" placeholder="点击选择>" @click="item => { if(true){showFreeType = true} }" :rules="[{ required: true, message: '请选择免租方式' }]" />
                    <van-field v-model="form.leaseYear" required type="digit" maxlength="2" @blur="changeRentList();$refs.form2.validate('leaseMonth')" name="leaseYear" label="租期（年）" placeholder="点击填写" :rules="[{ validator: item => { return Boolean((form.leaseMonth&&form.leaseMonth!=='0') || (form.leaseYear&&form.leaseYear!=='0')) }, message: '请填写租期' }]" />
                    <van-field v-model="form.leaseMonth" required type="digit" maxlength="2" @blur="changeRentList();$refs.form2.validate('leaseYear')" name="leaseMonth" label="租期（月）" placeholder="点击填写" :rules="[{ validator: item => { return Boolean((form.leaseMonth&&form.leaseMonth!=='0') || (form.leaseYear&&form.leaseYear!=='0')) }, message: '请填写租期' },{validator: item =>{return form.leaseMonth<12},message:'月数需小于12'}]" />
                    <table class="table ">
                        <tr class="head">
                            <td class="w15">序号</td>
                            <td class="w15">免租天数</td>
                            <td>开始日期</td>
                            <td>结束日期</td>
                            <td>月租金</td>
                        </tr>
                        <tr v-for="(item,index) in (form.propertyContractRentPeriodList||[])" :key="index">
                            <td>{{item.no}}</td>
                            <td>
                                <input type="number" pattern="[0-9]*" v-model="item.freeDays" @blur="changeFreeDays(index,item)" @input="item.freeDays = formatNumber(item.freeDays)">
                            </td>
                            <td>{{item.startDate?item.startDate.slice(0,10):''}}</td>
                            <td>{{item.endDate?item.endDate.slice(0,10):''}}</td>
                            <td :class="{'error':!item.monthPrice&&item.monthPrice!==0&&ruleErr}">
                                <input type="number" pattern="[0-9]*" v-model="item.monthPrice" :disabled="item.freeDays==item.maxDays&&item.maxDays&&form.freeType==1" @blur="index==0?changePrice():''" @input="item.monthPrice = formatNumber(item.monthPrice)">
                            </td>
                        </tr>
                    </table>
                    <van-field v-model="form.freeTotalDays" name="freeTotalDays" type="digit" disabled label="免租总天数" placeholder="点击填写" />
                    <!-- <van-field :value="form.startDate?form.startDate.slice(0,10):''" name="startDate" type="text" disabled label="开始付租日期" placeholder="点击填写" /> -->
                    <van-field :value="form.endDate?form.endDate.slice(0,10):''" name="endDate" type="text" disabled label="合约结束日期" placeholder="点击填写" />
                    <van-field v-model="form.payMonth" readonly clickable required type="test" name="payMonth" label="付" placeholder="点击选择>" @click="item => { showPayMonthType = true }" :rules="[{ validator: item => { return Boolean(form.payMonth&&form.payMonth!=='0') }, message: '请填写付款方式' }]" />
                    <van-field v-model="form.depositMonth" readonly clickable required type="test" name="depositMonth" label="押" placeholder="点击选择>" @click="item => { showDepositMonthType = true }" :rules="[{ validator: item => { return Boolean(form.depositMonth||form.depositMonth===0) }, message: '请填写付款方式' }]" />
                    <van-field v-model="form.deposit" required name="deposit" type="digit" label="押金" placeholder="点击填写" class="line" :rules="[{ validator: item => { return Boolean(form.deposit||form.deposit===0) }, message: '请填写押金' },{ validator :validNum0, message: '押金必须大于等于0且为整数' },{ validator :validDeposit, message: '押金必须大于等于支付方式对应的押金金额' }]" />
                    <van-field v-model="form.agentFee" required name="agentFee" type="digit" label="中介费" placeholder="点击填写" class="line" :rules="[{ validator: item => { return Boolean(form.agentFee)}, message: '请填写中介费' },{ validator :validNum0, message: '中介费必须大于等于0且为整数' }]" />
                    <van-field v-model="form.awardFee" required name="awardFee" type="digit" label="经纪人奖励" placeholder="点击填写" class="line" :rules="[{ validator: item => { return Boolean(form.awardFee) }, message: '请填写经纪人奖励' },{ validator :validNum0, message: '经纪人奖励必须大于等于0且为整数' }]" />
                </div>
                <!-- 托管 -->
                <div v-else>
                    <van-field readonly :clickable="!form.prevId" :disabled="Boolean(form.prevId)" required name="startDate" :value="form.startDate?form.startDate.slice(0,10):''" label="开始日期" placeholder="点击选择日期>" @click=" item => { if(!form.prevId){showStartDate = true} } " :rules="[{ required: true, message: '请选择日期' },{ validator: item => { return Boolean(form.startDate >= form.makeDate) }, message: '开始日期不能小于交房日期' }]" />
                    <van-field v-model="form.leaseYear" required type="digit" maxlength="2" @blur="$refs.form2.validate('leaseMonth');getEndDate()" name="leaseYear" label="租期（年）" placeholder="点击填写" :rules="[{ validator: item => { return Boolean((form.leaseMonth&&form.leaseMonth!=='0') || (form.leaseYear&&form.leaseYear!=='0')) }, message: '请填写租期' }]" />
                    <van-field v-model="form.leaseMonth" required type="digit" maxlength="2" @blur="$refs.form2.validate('leaseYear');getEndDate()" name="leaseMonth" label="租期（月）" placeholder="点击填写" :rules="[{ validator: item => { return Boolean((form.leaseMonth&&form.leaseMonth!=='0') || (form.leaseYear&&form.leaseYear!=='0')) }, message: '请填写租期' },{validator: item =>{return form.leaseMonth<12},message:'月数需小于12'}]" />
                    <van-field :value="form.endDate?form.endDate.slice(0,10):''" name="endDate" type="text" disabled label="结束日期" placeholder="点击填写" />
                    <van-field readonly clickable required name="guaranteedDate" :value="form.guaranteedDate?form.guaranteedDate.slice(0,10):''" label="保底出租日期" placeholder="点击选择日期>" @click=" item => { showGuaranteedDate = true } " :rules="[{ required: true, message: '请选择日期' },{ validator: item => { return Boolean(form.guaranteedDate >= form.makeDate) }, message: '保底出租日期不能小于交房日期' }]" />
                    <van-field v-model="form.deposit" required name="deposit" type="digit" label="保证金" placeholder="点击填写" :rules="[{ validator: item => { return Boolean(form.deposit||form.deposit===0) }, message: '请填写保证金' },{ validator :validNum0, message: '保证金必须大于等于0且为整数' }]" />
                    <van-field v-model="form.referencePrice" name="referencePrice" type="digit" label="参考租金价格" placeholder="点击填写" class="line" />
                </div>
                <van-field readonly clickable label="出租价格" />
                <van-field v-for="(item,index) in form.houseRoomPriceList" :key="index" v-model="item.price" name="deposit" type="digit" @blur="getAllPrice(item)" :label="item.roomNo?item.roomNo:'整租'" placeholder="点击填写" />
            </van-form>
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" @click="active = 0" :disabled="saveLoad" :loading="saveLoad">上一步</van-button>
                <van-button round block type="primary" @click="next2" :disabled="saveLoad" :loading="saveLoad">下一步</van-button>
            </div>
        </div>
        <!-- 第三步 -->
        <div v-if="active === 2" class="form3">
            <div v-for="(item,index) in  (form.materials||[])" :key="index">
                <div class="title">{{item.roomNo==="Pub"?"公区":item.roomNo}}
                    <van-button @click="showAssatsAdd(index)" class="icon" round icon="plus" type="primary" />
                </div>
                <table class="table ">
                    <tr class="head">
                        <td class="t1">名称</td>
                        <td class="t2">品类</td>
                        <td class="t3">规格</td>
                        <td class="t4">品牌</td>
                        <td class="t5">型号</td>
                        <td class="t6">数量</td>
                    </tr>
                    <div class="body" v-for="(item1,index1) in (item.materials||[])" :key="index1">
                        <van-swipe-cell>
                            <tr>
                                <td class="t1">{{item1.materialTypeName}}</td>
                                <td class="t2">{{item1.materialTypeParentName}}</td>
                                <td class="t3">{{item1.specification}}</td>
                                <td class="t4">{{item1.brand}}</td>
                                <td class="t5">{{item1.model}}</td>
                                <td class="t6">
                                    <i @click="assetsReduce(index,index1)" class="iconfont iconjian"></i>
                                    {{item1.count}}
                                    <i @click="assetsAdd(index,index1)" class="iconfont icontianjia"></i>
                                </td>
                            </tr>
                            <template #right>
                                <van-button @click="assetsDelete(index,index1)" square text="删除" type="danger" class="delete-button" />
                            </template>
                        </van-swipe-cell>
                    </div>
                </table>
            </div>
            <!-- <van-empty v-if="!form.materials.length" description="暂无资产" /> -->
            <div v-if="form.prevId" >
                    <div class="title">资产配置</div>
                    <van-checkbox-group  @change="changeUnuseAssets" v-model="result" ref="checkboxGroup">
                         <div class="assets">
                                <table class="table">
                            <tr class="head">
                                <td class="t1">名称</td>
                                <td class="t2">品类</td>
                                <td class="t3">规格</td>
                                <td class="t4">品牌</td>
                                <td class="t5">型号</td>
                                <td class="t6">归属</td>
                                <td class="t7">是否作废</td>
                            </tr>
                            <div  v-for="(item,index) in (unuseAssetsIdListData||[])" :key="index">
                              
                                    <tr>
                                        <td class="t1">{{item.materialTypeName}}</td>
                                        <td class="t2">{{item.materialTypeParentName}}</td>
                                        <td class="t3">{{item.specification}}</td>
                                        <td class="t4">{{item.brand}}</td>
                                        <td class="t5">{{item.model}}</td>
                                          <td class="t6">{{item.roomNo==="Pub"?"公区":item.roomNo}}</td>
                                        <td class="t7">
                                            <van-checkbox :name="item.assetsId"></van-checkbox>
                                           
                                        </td>
                                    </tr>
                                
                              
                            </div>
                        </table>
                         </div>
                        <!-- <van-checkbox name="a">复选框 a</van-checkbox>
                        <van-checkbox name="b">复选框 b</van-checkbox>
                        <van-checkbox name="c">复选框 c</van-checkbox> -->
                    </van-checkbox-group>
            </div>
                
               
           
         
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" @click="active = 1" :loading="saveLoad" :disabled="saveLoad">上一步</van-button>
                <van-button round block type="primary" @click="next3" :loading="saveLoad" :disabled="saveLoad">下一步</van-button>
            </div>
        </div>
        <!-- 第四步 -->
        <div v-if="active === 3" class="form4">
            <van-form ref="form4" input-align="right">
                <!-- 签约人 -->
                <div class="field van-cell--required">签约人证件照</div>
                <div class="body">
                    <div class="picCard">
                        <van-uploader  :before-read="beforeRead" :after-read="item => { idCardFrontUrl = [
              {
                url: upload_qiniu_addr + item.file.key  + `${isAddTextMask?imgMaskUrl:''}`,
                isImage: true
              }];
              $refs.form4.resetValidation('idCardFrontUrl')
            
              }" v-model="idCardFrontUrl " :max-count="1" />
                        <div class="text">
                            <van-field value="正面" name="idCardFrontUrl" disabled :rules="[{ validator :item => {return Boolean(idCardFrontUrl.length)||!imgUp}, message: '请上传正面图' }]" />
                        </div>
                    </div>
                    <div class="picCard">
                        <van-uploader :before-read="beforeRead" :after-read="item => { idCardBackUrl = [
              {
                url: upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,
                isImage: true
              }];
              $refs.form4.resetValidation('idCardBackUrl')}" v-model="idCardBackUrl" :max-count="1" />
                        <div class="text">
                            <van-field value="反面" name="idCardBackUrl" disabled :rules="[{ validator :item => {return Boolean(idCardBackUrl.length)||!imgUp}, message: '请上传反面图' }]" />
                        </div>
                    </div>
                </div>
                <!-- 电度数 -->
                <div class="field van-cell--required">电峰</div>
                <div class="body">
                    <div class="picCard">
                        <van-uploader :before-read="beforeRead" :after-read="item => { electricMaxUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: true
              }];
              $refs.form4.resetValidation('electricMaxUrl')}" v-model="electricMaxUrl" :max-count="1" />
                        <div class="text errorLeft">
                            <van-field name="electricMaxUrl" disabled :rules="[{ validator:item=>{return Boolean(electricMaxUrl.length)||!imgUp}, message: '请上传电峰图' }]" />
                        </div>
                    </div>
                    <div class="picCard">
                        <div class="text textBorder">
                            <van-field type="number" label="当前度数" name="electricMax" maxlength="11" v-model="form.electricMax" @input="form.electricTotal = accAdd(form.electricMin,form.electricMax)" border :placeholder="'当前:'+houseDegrees.lastElectricMax" :rules="[{ required: true, message: '请请输入电峰' },{ validator :validNum0Decimal2, message: '电峰必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="已结清度数" name="settleElectricMax" class="m-t" maxlength="11" v-model="form.settleElectricMax" @input="form.settleElectricTotal = accAdd(form.settleElectricMin,form.settleElectricMax)" border placeholder="已结清电峰度数" :rules="[{ required: true, message: '请输入已结清电峰度数' },{ validator :validNum0Decimal2, message: '已结清电峰度数必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="欠款金额" name="arrearElectricMax" class="m-t" maxlength="11" v-model="form.arrearElectricMax" @input="form.arrearElectricTotal = accAdd(form.arrearElectricMin,form.arrearElectricMax)" border placeholder="欠款电峰金额" :rules="[{ required: true, message: '请输入欠款电峰金额' },{ validator :validNum0Decimal2, message: '欠款电峰金额必须为正数或0，且最多保留两位小数' }]" />
                        </div>
                    </div>
                </div>
                <div class="field van-cell--required">电谷</div>
                <div class="body">
                    <div class="picCard">
                        <van-uploader :before-read="beforeRead" :after-read="item => { electricMinUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: true
              }];
              $refs.form4.resetValidation('electricMinUrl')}" v-model="electricMinUrl" :max-count="1" />
                        <div class="text errorLeft">
                            <van-field name="electricMinUrl" disabled :rules="[{ validator:item=>{return Boolean(electricMinUrl.length)||!imgUp}, message: '请上传电谷图' }]" />
                        </div>
                    </div>
                    <div class="picCard">
                        <div class="text textBorder">
                            <van-field type="number" label="当前度数" name="electricMinUrl" maxlength="11" v-model="form.electricMin" @input="form.electricTotal = accAdd(form.electricMin,form.electricMax)" :placeholder="'当前:'+houseDegrees.lastElectricMin" :rules="[{ required: true, message: '请输入电谷' },{ validator :validNum0Decimal2, message: '电谷必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="已结清度数" name="settleElectricMin" class="m-t" maxlength="11" v-model="form.settleElectricMin" @input="form.settleElectricTotal = accAdd(form.settleElectricMin,form.settleElectricMax)" border placeholder="已结清电谷度数" :rules="[{ required: true, message: '请输入已结清电谷度数' },{ validator :validNum0Decimal2, message: '已结清电谷度数必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="欠款金额" name="arrearElectricMin" class="m-t" maxlength="11" v-model="form.arrearElectricMin" @input="form.arrearElectricTotal = accAdd(form.arrearElectricMin,form.arrearElectricMax)" border placeholder="欠款电谷金额" :rules="[{ required: true, message: '请输入欠款电谷金额' },{ validator :validNum0Decimal2, message: '欠款电谷金额必须为正数或0，且最多保留两位小数' }]" />
                        </div>
                    </div>
                </div>
                <div class="field van-cell--required">电总</div>
                <div class="body">
                    <div class="picCard">
                        <van-uploader :before-read="beforeRead" :after-read="item => { electricTotalUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: true
              }];
              $refs.form4.resetValidation('electricTotalUrl')}" v-model="electricTotalUrl" :max-count="1" />
                        <div class="text errorLeft">
                            <van-field name="electricTotalUrl" disabled :rules="[{ validator:item=>{return Boolean(electricTotalUrl.length)||!imgUp}, message: '请上传电总图' }]" />
                        </div>
                    </div>
                    <div class="picCard">
                        <div class="text textBorder">
                            <van-field type="number" label="当前度数" name="electricTotalUrl" maxlength="11" v-model="form.electricTotal" :placeholder="'当前:'+houseDegrees.lastElectricTotal" :rules="[{ required: true, message: '请输入电总' },{ validator :validNum0Decimal2, message: '电总必须为正数或0，且最多保留两位小数' },{ validator:item=>{return !(form.electricTotal<houseDegrees.lastElectricTotal)}, message: `电总度数必须大于当前房源${houseDegrees.lastElectricTotal}` }]" />
                            <van-field type="number" label="已结清度数" name="settleElectricTotal" class="m-t" maxlength="11" v-model="form.settleElectricTotal" border placeholder="已结清电总度数" :rules="[{ required: true, message: '请输入已结清电总度数' },{ validator :validNum0Decimal2, message: '已结清电总度数必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="欠款金额" name="arrearElectricTotal" class="m-t" maxlength="11" v-model="form.arrearElectricTotal" border placeholder="欠款电总金额" :rules="[{ required: true, message: '请输入欠款电总金额' },{ validator :validNum0Decimal2, message: '欠款电总金额必须为正数或0，且最多保留两位小数' }]" />
                        </div>
                    </div>
                </div>
                <van-field v-model="form.electricCard" required name="deposit" type="text" label="电卡号" placeholder="点击填写" :rules="[{ required: true, message: '请输入电卡号' }]" />
                <!-- 水度数 -->
                <div class="field van-cell--required">水度数</div>
                <div class="body">
                    <div class="picCard">
                        <van-uploader :before-read="beforeRead" :after-read="item => { waterUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: true
              }];
              $refs.form4.resetValidation('waterUrl')}" v-model="waterUrl" :max-count="1" />
                        <div class="text errorLeft">
                            <van-field name="waterUrl" disabled :rules="[{ validator:item=>{return Boolean(waterUrl.length)||!imgUp}, message: '请上传水图' }]" />
                        </div>
                    </div>
                    <div class="picCard">
                        <div class="text textBorder">
                            <van-field type="number" label="当前度数" name="water" maxlength="11" v-model="form.water" :placeholder="'当前:'+houseDegrees.lastWater" :rules="[{ required: true, message: '请输入水度数' },{ validator :validNum0Decimal2, message: '水度数必须为正数或0，且最多保留两位小数' },{ validator:item=>{return !(form.water<houseDegrees.lastWater)}, message: `水度数必须大于当前房源${houseDegrees.lastWater}` }]" />
                            <van-field type="number" label="已结清度数" name="settleWater" maxlength="11" class="m-t" v-model="form.settleWater" border placeholder="已结清水金额" :rules="[{ required: true, message: '请输入已结清水金额' },{ validator :validNum0Decimal2, message: '已结清水金额必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="欠款金额" name="arrearWater" maxlength="11" class="m-t" v-model="form.arrearWater" border placeholder="欠款水金额" :rules="[{ required: true, message: '请输入欠款水金额' },{ validator :validNum0Decimal2, message: '欠款水金额必须为正数或0，且最多保留两位小数' }]" />
                        </div>
                    </div>
                </div>
                <van-field v-model="form.waterCard" required name="deposit" type="text" label="水卡号" placeholder="点击填写" :rules="[{ required: true, message: '请输入水卡号' }]" />
                <!-- 燃气度数 -->
                <div class="field van-cell--required">燃气度数</div>
                <div class="body">
                    <div class="picCard textBorder">
                        <van-uploader :before-read="beforeRead" :after-read="item => { gasUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: true
              }];
              $refs.form4.resetValidation('gasUrl')}" v-model="gasUrl" :max-count="1" />
                        <div class="text errorLeft">
                            <van-field name="gasUrl" disabled :rules="[{ validator:item=>{return Boolean(gasUrl.length)||!imgUp}, message: '请上传燃气图' }]" />
                        </div>
                    </div>
                    <div class="picCard">
                        <div class="text textBorder">
                            <van-field type="number" label="当前度数" name="gasUrl" maxlength="11" v-model="form.gas" :placeholder="'当前:'+houseDegrees.lastGas" :rules="[{ required: true, message: '请输入燃气度数' },{ validator :validNum0Decimal2, message: '燃气度数必须为正数或0，且最多保留两位小数' },{ validator:item=>{return !(form.gas<houseDegrees.lastGas)}, message: `燃气度数必须大于当前房源${houseDegrees.lastGas}` }]" />
                            <van-field type="number" label="已结清度数" name="settleGas" maxlength="11" class="m-t" v-model="form.settleGas" border placeholder="已结清燃气金额" :rules="[{ required: true, message: '请输入已结清燃气金额' },{ validator :validNum0Decimal2, message: '已结清燃气金额必须为正数或0，且最多保留两位小数' }]" />
                            <van-field type="number" label="欠款金额" name="arrearGas" maxlength="11" class="m-t" v-model="form.arrearGas" border placeholder="欠款燃气金额" :rules="[{ required: true, message: '请输入欠款燃气金额' },{ validator :validNum0Decimal2, message: '欠款燃气金额必须为正数或0，且最多保留两位小数' }]" />
                        </div>
                    </div>
                </div>
                <van-field v-model="form.gasCard" required name="deposit" type="text" label="燃气卡号" placeholder="点击填写" :rules="[{ required: true, message: '请输入燃气卡号' }]" />
                <van-field v-model="form.shareBillPerMonth" required name="shareBillPerMonth" type="text" label="物业管理及公摊水电费/月" placeholder="点击填写" :rules="[{ required: true, message: '请输入物业管理及公摊水电费/月' }]" />
                <van-field v-model="form.totalArrear" required name="totalArrear" type="text" label="物业管理及公摊水电费欠款金额" placeholder="点击填写" :rules="[{ required: true, message: '请输入物业管理及公摊水电费欠款金额' }]" />
                <van-field readonly clickable required name="settleDate" :value="form.settleDate?form.settleDate.slice(0,10):''" label="物业费及公摊水电已结算至" placeholder="点击选择日期>" @click=" item => { showSettleDate = true } " :rules="[{ required: true, message: '请选择日期' }]" />
                <!-- 合同 -->
                <div class="field van-cell--required">合同</div>
                <div class="body body1 errorLeft">
                    <van-uploader :before-read="beforeRead" :after-read="item => {contactUrl.pop();contactUrl.push({
            url: upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,
            isImage: true
          });$refs.form4.resetValidation('contactUrl')}" v-model="contactUrl" :max-count="9" />
                    <div class="text">
                        <van-field name="contactUrl" disabled :rules="[{ validator :item => {return Boolean(contactUrl.length)||!imgUp}, message: '请上传合同图' }]" />
                    </div>
                </div>
                <!-- 产权 -->
                <div class="field van-cell--required">产权</div>
                <div class="body body1 errorLeft">
                    <van-uploader :before-read="beforeRead" :after-read="item => {propertyUrl.pop();propertyUrl.push({
            url: upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,
            isImage: true
          });$refs.form4.resetValidation('propertyUrl')}" v-model="propertyUrl" :max-count="9" />
                    <div class="text">
                        <van-field name="propertyUrl" disabled :rules="[{ validator :item => {return Boolean(propertyUrl.length)||!imgUp}, message: '请上传产权图' }]" />
                    </div>
                </div>
                <!-- 银行卡 -->
                <div class="field" :class="{'van-cell--required':form.payType==3}">银行卡</div>
                <div class="body errorLeft">
                    <div class="picCard textBorder">
                        <van-uploader :before-read="beforeRead" :after-read="item => { cardUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: true
              }];
              $refs.form4.resetValidation('cardUrl')}" v-model="cardUrl" :max-count="1" />
                        <div class="text">
                            <van-field name="cardUrl" disabled :rules="[{ validator :item => {return Boolean(cardUrl.length)||!imgUp||form.payType!=3}, message: '请上传银行卡图' }]" />
                        </div>
                    </div>
                </div>
                <!-- 其他 -->
                <div class="field">其它</div>
                <div class="body body1 errorLeft">
                    <van-uploader :before-read="beforeRead" :after-read="item => {otherUrl.pop();otherUrl.push({
            url: upload_qiniu_addr + item.file.key,
            isImage: true
          })}" v-model="otherUrl" :max-count="9" />
                </div>
                <!-- 视频 -->
                <div class="field">视频</div>
                <div class="body">
                    <div class="picCard textBorder">
                        <van-uploader :before-read="beforeReadVideo" :after-read="item => { videoUrl = [
              {
                url: upload_qiniu_addr + item.file.key,
                isImage: false
              }];playerOptions.sources[0].src = upload_qiniu_addr + item.file.key}" v-model="videoUrl" :max-count="1" accept="video/*">
                            <template #preview-cover="{ file }">
                                <div class="preview-cover">
                                    <div class="cover" @click="videoStart"></div>
                                    <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
                                    <!-- <video :src="videoUrl[0]?videoUrl[0].url:''" :enableNative="true"></video> -->
                                </div>
                            </template>
                        </van-uploader>
                    </div>
                </div>
                <van-field readonly clickable required name="propertyFileType" :value="propertyFileTypeList[form.propertyFileType-1]" label="产权证明文件类型" placeholder="点击选择>" @click=" item => { showPropertyFileType = true } " :rules="[{ required: true, message: '请选择产权证明文件类型' }]" />
                <van-field v-model="form.otherPropertyType" v-if="form.propertyFileType==4" required name="otherPropertyType" type="text" label="其他产权证明类型说明" placeholder="点击填写" :rules="[{ required: true, message: '请输入其他产权证明类型说明' }]" />
                <van-field v-model="form.propertyFileNo" required name="propertyFileNo" type="text" label="产权证明文件编码" placeholder="点击填写" :rules="[{ required: true, message: '请输入产权证明文件编码' }]" />
                <van-field readonly clickable required name="equityType" :value="equityTypeList[form.equityType-1]" label="产权性质" placeholder="点击选择>" @click=" item => { showEquityType = true } " :rules="[{ required: true, message: '请选择产权性质' }]" />
                <van-field v-model="form.propertyOwner" 
                    required name="propertyOwner"
                    type="text" label="产权人"
                    placeholder="点击填写" 
                    :rules="[{ required: true, message: '请输入产权人' }]" 
                />
                <van-field readonly 
                    :value="equityIdTypeList[form.equityIdType-1]" label="产权人证件类型" 
                    required
                    placeholder="点击选择>" 
                    clearable
                    @click="item => { showEquityIdType = true}" 
                    :rules="[{ required: true, message: '请选择产权人证件类型' }]" 
                />
                <van-field type="text"
                  required 
                 v-model="form.equityIdNo" 
                 name="equityIdNo" label="产权人证件号码" placeholder="点击填写" 
                 :rules="[{ required: true, message: '请填写产权人证件号码' },
                 { validator :validIdNoForEquityIdNo, message: '请输入产权人正确的身份证' }]" 
                 />

                 <van-field v-model="form.located" 
                    required name="located"
                    type="text" label="坐落"
                    placeholder="点击填写" 
                    :rules="[{ required: true, message: '请输入坐落(必须和产权证明文件上的坐落内容完全一致)' }]" 
                />

                 <van-field 
                    readonly clickable required name="purpose" 
                    :value="purposeList[form.purpose-1]" label="用途"
                    placeholder="点击选择>" 
                    @click=" item => { showPurpose = true } " 
                    :rules="[{ required: true, message: '请选择用途(产权证明文件上记载的用途)' }]" 
                />
                  <van-field 
                    readonly clickable required name="rentPurpose" 
                    :value="rentPurposeList[form.rentPurpose-1]" label="租赁用途"
                    placeholder="点击选择>" 
                    @click=" item => { showRentPurpose = true } " 
                    :rules="[{ required: true, message: '请选择租赁用途' }]" 
                />
                <van-field v-model="form.qiuQuanNo" required name="qiuQuanNo" type="text" label="丘权号" placeholder="点击填写" :rules="[{ required: true, message: '请输入丘权号' }]" />
             
                <van-field v-for="(item,index) in form.remarks" :key="index" v-model="form.remarks[index]" type="text" :label="'备注'+(index+1)" placeholder="点击填写" />
            </van-form>
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" @click="active = 2" :loading="saveLoad" :disabled="saveLoad">上一步</van-button>
                <van-button round block type="primary" @click="next4" :loading="saveLoad" :disabled="saveLoad">{{form.tenantType!=2?'下一步':'保存'}}</van-button>
            </div>
        </div>
        <!-- 第五步 施工宝 -->
        <div v-if="active === 4 &&  form.tenantType != 2" class="form5">
            <van-cell title="总计" style="font-weight: bold" :value="total" />
            <div class="construct_list">
                <div class="top">
                    <ul style="display: flex; justify-content: space-between; width: 100%">
                    <li>施工项</li>
                    <li>类型</li>
                    <li style="flex: 1">单价</li>
                    <li>数量</li>
                    <li>备注</li>
                    </ul>
                </div>
                <div class="list">
                    <ul style="width：100%">
                    <li
                        @click="construct(item, index)"
                        v-for="(item, index) in itemList"
                        :key="index"
                        style="display: flex; justify-content: space-between"
                    >
                        <span>{{ item.projectName }}</span>
                        <span>{{
                        item.priceType == null ? "" : item.priceType > 1 ? "修补" : "新增"
                        }}</span>
                        <span style="flex: 1"
                        >{{ item.priceType ? (item.price?item.price:0) : 0 }}{{ item.priceType ? item.priceUnit : "" }}</span
                        >
                        <!-- <span style="flex: 1"
                        >{{
                            item.price
                        }}{{ item.priceType ? item.priceUnit : "" }}</span
                        > -->
                        <span>{{ item.count }}</span>
                        <span>{{ item.remark }}</span>
                    </li>
                    </ul>
                </div>
            </div>
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" @click="active = 3" :loading="saveLoad" :disabled="saveLoad">上一步</van-button>
                <van-button round block type="primary" @click="save" :loading="saveLoad" :disabled="saveLoad">保存</van-button>
            </div>
        </div>
        <!-- 房源搜索 -->
        <transition name="van-slide-right">
            <div v-if="showHouse" class="search">
                <form action="/">
                    <van-search v-model="searchValueHouse" shape="round" show-action placeholder="请输入房源地址搜索" @input="onSearchHouse" @search="onSearchHouse" @cancel="onCancel" />
                </form>
                <van-cell v-for="house in houseList" :key="house.id" :title="house.address" icon="wap-home-o" @click="changeHouse(house)"></van-cell>
                <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueHouse&&!houseList.length">暂无数据</div>
            </div>
        </transition>
        <!-- 业主搜索 -->
        <transition name="van-slide-right">
            <div v-if="showProperty" class="search">
                <form action="/">
                    <van-search v-model="searchValueProperty" shape="round" show-action placeholder="请输入手机号搜索" @input="onSearchProperty" @search="onSearchProperty" @cancel="onCancel" />
                </form>
                <van-cell v-for="property in propertyList" :key="property.id" :title="property.name + '-' + property.phone" icon="user-o" @click="changeProperty(property)"></van-cell>
                <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueProperty&&!propertyList.length">暂无数据</div>
            </div>
        </transition>
        <!-- 证件类型 -->
        <van-popup v-model="showIdType" position="bottom">
            <van-picker show-toolbar :columns="idTypeList1" @confirm="(item,index) => { form.idType = index/1+1;showIdType=false;$refs.form1.resetValidation('idNo')}" @cancel="showIdType = false" />
        </van-popup>
        <!-- 紧急联系人关系 -->
        <van-popup v-model="showContact" position="bottom">
            <van-picker show-toolbar :columns="contactList" @confirm="(item,index) => { form.contactRelation = index/1+1;showContact=false }" @cancel="showContact = false" />
        </van-popup>
        <!-- 支付方式 -->
        <van-popup v-model="showPayType" position="bottom">
            <van-picker show-toolbar :columns="payTypeList" @confirm="changePay" @cancel="showPayType = false" />
        </van-popup>
        <!-- 收款账号 -->
        <van-popup v-model="showReceipt" position="bottom">
            <van-picker show-toolbar :columns="receiptList" @confirm="changeReceipt" @cancel="showReceipt = false">
                <template #option='item'>
                    {{item.accountName + '-' + item.bankAccount}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 开户行 -->
        <van-popup v-model="showBank" position="bottom">
            <van-picker show-toolbar :columns="bankList" @confirm="(item,index) => { form.bankName = item.name;showBank=false }" @cancel="showBank = false">
                <template #option='item'>
                    {{item.name}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 交房日期 -->
        <van-popup v-model="showMakeDate" position="bottom">
            <van-datetime-picker type="date" :value="nowDate" @confirm="makeDateConfirm" @cancel="showMakeDate = false" />
        </van-popup>
        <!-- 生效日期 -->
        <van-popup v-model="showActiveDate" position="bottom">
            <van-datetime-picker type="date" :value="nowDate" @confirm="activeDateConfirm" @cancel="showActiveDate = false" />
        </van-popup>
        <!-- 免租方式 -->
        <van-popup v-model="showFreeType" position="bottom">
            <van-picker show-toolbar :columns="freeTypeList" @confirm="(item,index) => { form.freeType = index+1;showFreeType=false;changeRentList();$refs.form2.resetValidation('freeType')}" @cancel="showFreeType = false" />
        </van-popup>
        <!-- 付款方式 -->
        <van-popup v-model="showPayMonthType" position="bottom">
            <van-picker show-toolbar :columns="[1,3,6,12]" @confirm="(item,index) => { form.payMonth = item;showPayMonthType=false;$refs.form2.resetValidation('payMonth')}" @cancel="showPayMonthType = false" />
        </van-popup>
        <!-- 付款方式 -->
        <van-popup v-model="showDepositMonthType" position="bottom">
            <van-picker show-toolbar :columns="[0,1,2,3]" @confirm="(item,index) => { form.depositMonth = item;showDepositMonthType=false;changePrice();$refs.form2.resetValidation('depositMonth')}" @cancel="showDepositMonthType = false" />
        </van-popup>
        <!-- 开始日期 -->
        <van-popup v-model="showStartDate" position="bottom">
            <van-datetime-picker type="date" :value="nowDate" @confirm="startDateConfirm" @cancel="showStartDate = false" />
        </van-popup>
        <!-- 保底出租日期 -->
        <van-popup v-model="showGuaranteedDate" position="bottom">
            <van-datetime-picker type="date" :value="nowDate" @confirm="guaranteedDateConfirm" @cancel="showGuaranteedDate = false" />
        </van-popup>

        <!-- 新增资产 -->
        <transition name="van-slide-right">
            <div v-if="showAssets" class="assets search">
                <van-tabs v-model="assetsActive">
                    <van-tab title="物料库"></van-tab>
                    <van-tab title="自定义资产"></van-tab>
                </van-tabs>
                <div v-if="assetsActive ==0" class="query">
                    <van-button class="font5" type="default" @click="showMaterialType1 = true">
                        {{materialTypeName||'一级品类'}}
                        <van-icon name="arrow-down" />
                    </van-button>
                    <van-button class="font5" type="default" @click="showMaterialType2 = true">
                        {{childTypeName||'二级品类'}}
                        <van-icon name="arrow-down" />
                    </van-button>
                </div>
                <div v-if="assetsActive ==0">
                    <div class="fixedH">
                        <van-list v-model="assetsLoading" :finished="assetsFinished" :immediate-check="false" finished-text="没有更多了" offset="50" @load="assetsOnLoad">
                            <van-checkbox-group v-model="assetsChecked">
                                <van-cell-group>
                                    <van-cell v-for="(item ,index) in assetsList" clickable :key="index" :title="item.materialName" :label="(item.brand||'暂无')+' - '+(item.specification||'暂无')+' - '+(item.model||'暂无')" @click="toggle(index)">
                                        <template #right-icon>
                                            <van-checkbox :name="item" ref="checkboxes" />
                                        </template>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </van-list>
                    </div>
                </div>
                <div v-if="assetsActive ==1">
                    <van-form ref="formAssets" label-width="110px" input-align="right">
                        <van-field readonly clickable required name="materialTypeParentId" :value="assetsQuery.materialTypeParentName" label="一级品类" placeholder="点击选择>" @click="showMaterialType11 = true" :rules="[{ required: true, message: '请选择一级品类' }]" />
                        <van-field v-if="assetsQuery.materialTypeParentId" readonly clickable required name="materialTypeId" :value="assetsQuery.materialTypeName" label="资产名称" placeholder="点击选择>" @click="showMaterialType22 = true" :rules="[{ required: true, message: '请选择资产' }]" />
                        <van-field v-if="assetsQuery.materialTypeId" readonly clickable required name="specification" :value="assetsQuery.specification" label="规格" placeholder="点击选择>" @click="showMaterialType33 = true" :rules="[{ required: false, message: '请选择规格' }]" />
                        <van-field v-model="assetsQuery.brand" required name="brand" type="text" label="品牌" placeholder="点击填写" :rules="[{ required: true, message: '请填写品牌' }]" />
                        <van-field v-model="assetsQuery.model" required name="model" type="text" label="型号" placeholder="点击填写" :rules="[{ required: true, message: '请填写型号' }]" />
                        <van-field v-model="assetsQuery.price" required name="price" type="number" label="价格" placeholder="点击填写" :rules="[{ required: true, message: '请填写价格' }]" />
                    </van-form>
                </div>
                <div style="height:1.2rem;"></div>
                <div class="bottom">
                    <van-button class="font5" type="default" @click="showRoom = true">
                        {{form.materials[nowRoom].roomNo==="Pub"?"公区":form.materials[nowRoom].roomNo}}
                        <van-icon name="arrow-down" />
                    </van-button>
                    <van-button class="font5" type="primary" @click="assetsConfirm">确定</van-button>
                    <van-button class="font5" type="default" @click="assetsCancel">取消</van-button>
                </div>
            </div>
        </transition>
        <!-- 新增资产选择一级品类 -->
        <van-popup v-model="showMaterialType1" position="bottom">
            <van-picker show-toolbar :columns="materialTypeList1" @confirm="materialTypeConfirm1" @cancel="showMaterialType1 = false">
                <template #option='item'>
                    {{item.name}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 新增资产选择二级品类 -->
        <van-popup v-model="showMaterialType2" position="bottom">
            <van-picker show-toolbar :columns="materialTypeList2" @confirm="materialTypeConfirm2" @cancel="showMaterialType2 = false">
                <template #option='item'>
                    {{item.name}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 新增资产选择房间 -->
        <van-popup v-model="showRoom" position="bottom">
            <van-picker show-toolbar :columns="form.materials" @confirm="(item,index) => { nowRoom = index;showRoom=false }" @cancel="showRoom = false">
                <template #option='item'>
                    {{item.roomNo==="Pub"?"公区":item.roomNo}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 自定义资产选择一级品类 -->
        <van-popup v-model="showMaterialType11" position="bottom">
            <van-picker show-toolbar :columns="materialTypeList11" @confirm="materialTypeConfirm11" @cancel="showMaterialType11 = false">
                <template #option='item'>
                    {{item.name}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 自定义资产选择二级品类 -->
        <van-popup v-model="showMaterialType22" position="bottom">
            <van-picker show-toolbar :columns="materialTypeList22" @confirm="materialTypeConfirm22" @cancel="showMaterialType22 = false">
                <template #option='item'>
                    {{item.name}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 自定义资产选择三级规格 -->
        <van-popup v-model="showMaterialType33" position="bottom">
            <van-picker show-toolbar :columns="materialTypeList33" @confirm="item=>{assetsQuery.specification =item;showMaterialType33 = false}" @cancel="showMaterialType33 = false" />
        </van-popup>
        <!-- 物业费及公摊水电已结算至 -->
        <van-popup v-model="showSettleDate" position="bottom">
            <van-datetime-picker type="date" :value="nowDate" @confirm="item=>{form.settleDate= formatDate(item) + ' 00:00:00';showSettleDate = false}" @cancel="showSettleDate = false" />
        </van-popup>
        <!-- 产权证明文件类型 -->
        <van-popup v-model="showPropertyFileType" position="bottom">
            <van-picker show-toolbar :columns="propertyFileTypeList" @confirm="(item,index) => { form.propertyFileType = index/1+1;showPropertyFileType=false;form.otherPropertyType='' }" @cancel="showPropertyFileType = false" />
        </van-popup>
         <!-- 产权性质 -->
        <van-popup v-model="showEquityType" position="bottom">
            <van-picker show-toolbar :columns="equityTypeList" @confirm="(item,index) => { form.equityType = index/1+1;showEquityType=false; }" @cancel="showEquityType = false" />
        </van-popup>
        <!-- 产权人证件类型 -->
         <van-popup v-model="showEquityIdType" position="bottom">
            <van-picker show-toolbar :columns="equityIdTypeList" @confirm="(item,index) => { form.equityIdType = index/1+1;showEquityIdType=false;$refs.form4.resetValidation('equityIdNo')}" @cancel="showEquityIdType = false" />
        </van-popup>
            <!-- 用途 -->
        <van-popup v-model="showPurpose" position="bottom">
            <van-picker show-toolbar :columns="purposeList" @confirm="(item,index) => { form.purpose = index/1+1;showPurpose=false; }" @cancel="showPurpose = false" />
        </van-popup>
          <!-- 租赁用途-->
        <van-popup v-model="showRentPurpose" position="bottom">
            <van-picker show-toolbar :columns="rentPurposeList" @confirm="(item,index) => { form.rentPurpose = index/1+1;showRentPurpose=false; }" @cancel="showRentPurpose = false" />
        </van-popup>
        <!-- 视频预览 -->
        <!-- <div v-show="videoShow" class="videoP van-image-preview">
            <div class="bg" @click="videoShow = false">
                <video :src="videoUrl[0]?videoUrl[0].url:''" controls></video>
                <div class="close" @click="videoShow = false">
                    <i class="iconfont iconguanbi"></i>
                </div>
            </div>
        </div> -->
        <!-- 资产详情 -->
        <!-- <van-dialog v-model="showAssets" title="资产详情" show-cancel-button :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true">
            <van-cell title="名称" :value="asstesDetail.materialTypeName" />
            <van-cell title="品类" :value="asstesDetail.materialTypeParentName" />
            <van-cell title="规格" :value="asstesDetail.specification" />
            <van-cell title="品牌" :value="asstesDetail.brand" />
            <van-cell title="型号" :value="asstesDetail.model" />
        </van-dialog> -->
        <van-popup
        :close-on-click-overlay="false"
        style="width: 90%; padding: 15px 20px; border-radius: 4px"
        v-model="showEdit"
        position="center"
        >
        <h3 style="margin: 0.24rem 0">施工项编辑</h3>
        <van-form @submit="onSubmitForm">
            <van-field
            name="施工项"
            label="施工项"
            readonly
            v-model="projectName"
            />
            <van-field
            name="priceType"
            label="类型"
            :rules="[{ required: true, message: '请填写类型' }]"
            >
            <template #input>
                <van-radio-group
                @change="radioChange"
                v-model="priceType"
                direction="horizontal"
                >
                <van-radio name="1">新增</van-radio>
                <van-radio name="2">修补</van-radio>
                </van-radio-group>
            </template>
            </van-field>
            <van-field name="单价" label="单价" readonly v-model="danjia" />
            <van-field
            type="number"
            name="数量"
            label="数量"
            v-model="count"
            :rules="[{ required: true, message: '请填写数量' }, {
                    validator: validNum0,
                    message: '数量必须为整数或0',
                },]"
            />
            <van-field
            v-model="remark"
            rows="2"
            autosize
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
            show-word-limit
            />
            <div style="margin: 16px; display: flex; justify-content: space-around">
            <van-button
                size="small"
                @click="cancel"
                style="width: 30%"
                round
                block
                type="default"
                native-type="reset"
                >取消</van-button
            >
            <van-button
                size="small"
                style="width: 30%"
                round
                block
                type="primary"
                native-type="submit"
                >确认</van-button
            >
            </div>
        </van-form>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    validPhone,
    validEmail,
    validIdNo,
    validNum0Decimal2,
    validNum100,
    validNum0,
} from "@/utils/validate";
import {
    formatDate,
    getEndDate,
    getNdaysDate,
    accAdd,
    accSub,
    accMul,
    deepClone
} from "@/utils/index";
import request from "@/utils/request";
import {
    requestFssHouseList,
    requestHouseContract,
    requestPhoneList,
    requestPReceipt,
    requestFssContractCreate,
    requestQiniuToken,
    requestFssContractDetail,
    requestMaterialList,
    requestMaterialTypeTree,
    requestMaterialChild,
    requestMaterialChild3,
    requestBankSelect,
    requestJointOrderContractConstructDetail,
  requestJointOrderConstructDetailLast,
  requestUnuseAssetsIdList,
  requestJointOrderConstructSaveOrUpdate,
} from "@/api";
import { imgUp, imgMaskUrl, isAddTextMask } from "@/common/js/constant.js";
import { compress, compressAccurately } from "image-conversion";
export default {
    name: "fssContractAdd",
    data() {
        return {
            imgMaskUrl ,
            isAddTextMask,
            imgUp: imgUp,
            active:0,
            activeMax: 0, //用户已经走到那一步（之前的步骤可以随意跳转）
            saveLoad: false,
            form: {
                contractId: "",
                operationNo: 1,
                tenantType: 1, //承租方式
                propertyPhone: "", //业主电话
                propertyName: "", //业主姓名
                idType: "", //证件类型
                idNo: "", //证件号码
                contactName: "", //紧急联系人姓名
                contactRelation: "", //紧急联系人关系
                contactPhone: "", //紧急联系人电话
                payType: "", //支付方式
                bankAccount: "", //收款账号
                accountName: "", //收款人姓名
                bankName: "", //银行名称
                bankBranchName: "",
                makeDate: "", //交房日期
                activeDate: "", //生效日期
                startDate: "", //开始日期
                leaseYear: "", //租期年
                leaseMonth: "", //租期月
                endDate: "", //结束日期
                guaranteedDate: "", //保底出租日期
                deposit: "", //押金
                agentFee:"", //中介费
                awardFee:"", //经纪人奖励
                referencePrice: "", //参考租金价格
                houseRoomPriceList: [],
                houseId: "", //房源id
                materials: [], //资产
                unuseAssetsIdList:[],
                idCardFrontUrl: "", //身份证正面
                idCardBackUrl: "", //身份证反面
                electricTotalUrl: "", //电总图
                electricMaxUrl: "", //电峰图
                electricMinUrl: "", //电谷图
                electricTotal: "", //电总
                electricMax: "", //电峰
                electricMin: "", //电谷
                waterUrl: "", //水图
                water: "", //水
                gasUrl: "", //燃气图
                gas: "", //燃气
                electricCard: "",
                waterCard: "",
                gasCard: "",
                contactUrl: "", //合约
                cardUrl: "", //银行卡
                propertyUrl: "", //产权
                otherUrl: "", //其它
                videoUrl: "", //视频
                settleElectricMax: "",
                settleElectricMin: "",
                settleElectricTotal: "",
                settleWater: "",
                settleGas: "",
                arrearWater: "",
                arrearElectricMax: "",
                arrearElectricMin: "",
                arrearElectricTotal: "",
                arrearGas: "",
                shareBillPerMonth: "",
                settleDate: "",
                totalArrear: "",
                //包租
                freeType: "", //免租方式
                propertyContractRentPeriodList: [], //每年约定租期
                freeTotalDays: 0, //免租总天数
                payMonth: "", //付几
                depositMonth: "", //押几
                propertyFileType: "", //产权证明文件类型
                propertyFileNo: "", //产权证明文件编码
                otherPropertyType: "", //其他产权证明类型说明
                equityType:"",//产权性质
                equityIdType:"",//产权人证件类型
                equityIdNo:"",//产权人证件号
                located:"",//坐落
                purpose:"",//用途
                rentPurpose:"",//租赁用途
                qiuQuanNo: "", //丘权号
                propertyOwner: "", //产权人
                remarks: ["", "", "", ""],
            },
            house:{},
            ruleErr: false,
            disable: {
                house: false,
                property: false,
            },
            //---step1---
            //搜索房源
            searchLoad: false,
            showHouse: false,
            houseNow: {},
            searchValueHouse: "",
            houseList: [],
            //搜索业主
            showProperty: false,
            propertyNow: {},
            searchValueProperty: "",
            propertyList: [],
            showIdType: false,
            showContact: false,
            showPayType: false,
            showReceipt: false,
            accountType: 1,
            receiptNow: {},
            searchValueReceipt: "",
            receiptList: [],
            qiniuData: {
                token: "",
                key: "",
            },
            showBank: false,
            bankList: [],
            //---step2---
            nowDate: new Date(),
            showMakeDate: false,
            showActiveDate: false,
            showFreeType: false,
            showPayMonthType: false,
            showDepositMonthType: false,
            freeTypeList: ["内置免租期", "外挂免租期"],
            showStartDate: false,
            showGuaranteedDate: false,
            //---setp3---
            showAssets: false,
            assetsActive: 0,
            //物料
            assetsLoading: false,
            assetsFinished: false,
            materialTypeName: "",
            childTypeName: "",
            assetsSearchQuery: {
                materialTypeId: "",
                childTypeId: "",
                pageNumber: 1,
                pageSize: 20,
            },
            assetsList: [],
            assetsChecked: [],
            nowRoom: "",
            showRoom: false,
            showMaterialType1: false,
            materialTypeList1: [],
            showMaterialType2: false,
            materialTypeList2: [],
            //自定义资产
            assetsQuery: {
                materialTypeParentId: "",
                materialTypeParentName: "",
                materialTypeId: "",
                materialTypeName: "",
                specification: "",
                brand: "",
                model: "",
                price: "",
            },
            showMaterialType11: false,
            materialTypeList11: [],
            showMaterialType22: false,
            materialTypeList22: [],
            showMaterialType33: false,
            materialTypeList33: [],
            unuseAssetsIdListData:[],
            result:[],
            //---setp4---
            houseDegrees: {},
            idCardFrontUrl: [], //签约人身份证正面
            idCardBackUrl: [], //签约人身份证反面
            electricTotalUrl: [], //电总
            electricMaxUrl: [], //电峰
            electricMinUrl: [], //电谷
            waterUrl: [], //水
            gasUrl: [], //燃气
            contactUrl: [],
            propertyUrl: [],
            cardUrl: [],
            otherUrl: [], //其他
            videoUrl: [],
            showPropertyFileType: false,
            showEquityType:false,
            showEquityIdType:false,
            showPurpose:false,
            showRentPurpose:false,
            videoShow: false,
            showSettleDate: false,
            player: null,
            //视频
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        src: "", // 路径
                        type: "video/mp4", // 类型
                    },
                ],
                // width: document.documentElement.clientWidth,
                controlBar: false,
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                // controlBar: {
                //     timeDivider: false, // 当前时间和持续时间的分隔符
                //     durationDisplay: false, // 显示持续时间
                //     remainingTimeDisplay: false, // 是否显示剩余时间功能
                //     fullscreenToggle: true // 是否显示全屏按钮
                // }
            },
            showEdit: false,
            projectName: "",
            priceType: 1,
            priceUnit: "",
            price: "",
            count: "",
            remark: "",
            index: 0,
            danjia: "",
            addPrice: "",
            repairPrice: "",
            itemList:[],
            totalPrice:null,
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "idTypeList1",
            "contactList",
            "upload_qiniu_addr",
            "payTypeList",
            "propertyFileTypeList",
            "equityTypeList",
            "equityIdTypeList",
            "purposeList",
            "rentPurposeList"

        ]),
        total: function () {
        // console.log('计算属性', this.message)
        let totalPrice = 0;
        this.itemList.forEach((item, index) => {
            if(!item.priceType){
            return 0
            }
            totalPrice += accMul(item.price , item.count)
            this.totalPrice = totalPrice;
        });
        return totalPrice + " 元";
        },
    },
    created() {
        if (this.$route.query.contractId) {
            //修改
            this.getDetail(this.$route.query.contractId);
            this.disable.house = true;
        } else if (this.$route.query.prevContractId) {
            //续签
            this.getDetail(this.$route.query.prevContractId,2).then(res=>{
                   this.getUnuseAssetsIdList()
            });
            this.disable.house = true;
        }
    },
    mounted() {
        this.getQiniuToken();
    },
    methods: {
        getDetail(id,type) {
            return new Promise((resolve, reject) => {
                requestFssContractDetail(id)
                    .then((res) => {
                        this.houseNow = res.data.house;
                        this.accountType = res.data.propertyReceipt.id ? 1 : 2;
                        //第四步图片--
                        if (res.data.image) {
                            this.idCardFrontUrl = res.data.image.idCardFront
                                ? [
                                      {
                                          url: res.data.image.idCardFront + `${isAddTextMask?imgMaskUrl:''}`,
                                          isImage: true,
                                      },
                                  ]
                                : []; //签约人身份证正面
                            this.idCardBackUrl = res.data.image.idCardBack
                                ? [
                                      {
                                          url: res.data.image.idCardBack + `${isAddTextMask?imgMaskUrl:''}`,
                                          isImage: true,
                                      },
                                  ]
                                : []; //签约人身份证反面
                            this.electricTotalUrl = res.data.image.electricTotal
                                ? [
                                      {
                                          url: res.data.image.electricTotal,
                                          isImage: true,
                                      },
                                  ]
                                : []; //电总
                            this.electricMaxUrl = res.data.image.electricMax
                                ? [
                                      {
                                          url: res.data.image.electricMax,
                                          isImage: true,
                                      },
                                  ]
                                : []; //电峰
                            this.electricMinUrl = res.data.image.electricMin
                                ? [
                                      {
                                          url: res.data.image.electricMin,
                                          isImage: true,
                                      },
                                  ]
                                : []; //电谷
                            this.waterUrl = res.data.image.water
                                ? [{ url: res.data.image.water, isImage: true }]
                                : []; //水
                            this.gasUrl = res.data.image.gas
                                ? [{ url: res.data.image.gas, isImage: true }]
                                : []; //燃气
                            this.cardUrl = res.data.image.bankCard
                                ? [
                                      {
                                          url: res.data.image.bankCard,
                                          isImage: true,
                                      },
                                  ]
                                : []; //银行卡
                            this.videoUrl = res.data.image.video
                                ? [{ url: res.data.image.video }]
                                : []; //视频
                            this.playerOptions.sources[0].src =
                                res.data.image.video;
                            this.contactUrl = []; //合同
                            if (res.data.image) {
                                if (res.data.image.contact) {
                                    let contactUrl = res.data.image.contact.split(
                                        ";"
                                    );
                                    contactUrl.forEach((d) => {
                                        this.contactUrl.push({
                                            url: d +  `${isAddTextMask?imgMaskUrl:''}`,
                                            isImage: true,
                                        });
                                    });
                                }
                                this.propertyUrl = []; //产权
                                if (res.data.image.property) {
                                    let propertyUrl = res.data.image.property.split(
                                        ";"
                                    );
                                    propertyUrl.forEach((d) => {
                                        this.propertyUrl.push({
                                            url: d +  `${isAddTextMask?imgMaskUrl:''}`,
                                            isImage: true,
                                        });
                                    });
                                }
                                this.otherUrl = []; //其他
                                if (res.data.image.other) {
                                    let otherUrl = res.data.image.other.split(
                                        ";"
                                    );
                                    otherUrl.forEach((d) => {
                                        this.otherUrl.push({
                                            url: d,
                                            isImage: true,
                                        });
                                    });
                                }
                            }
                        }

                        //step1
                        this.form.contractId = res.data.contractId;
                        this.form.prevId = res.data.contract.prevId;
                        this.form.status = res.data.contract.status;
                        this.form.houseId = res.data.house.id; //房源id
                        this.form.tenantType = res.data.contract.tenantType; //承租方式
                        this.form.propertyPhone = res.data.property.phone; //业主电话
                        this.form.propertyName = res.data.property.name; //业主姓名
                        this.form.propertyId = res.data.property.id; //业主id
                        this.form.idType = res.data.property.idType; //证件类型
                        this.form.idNo = res.data.property.idNo; //证件号码
                        this.form.contactName = res.data.property.contactName; //紧急联系人姓名
                        this.form.contactRelation =
                            res.data.property.contactRelation; //紧急联系人关系
                        this.form.contactPhone = res.data.property.contactPhone; //紧急联系人电话
                        this.form.payType = res.data.propertyReceipt.payType; //支付方式
                        this.form.propertyReceiptId =
                            res.data.propertyReceipt.id; //收款id
                        this.form.bankAccount =
                            res.data.propertyReceipt.bankAccount; //收款账号
                        this.form.accountName =
                            res.data.propertyReceipt.accountName; //收款人姓名
                        this.form.bankName = res.data.propertyReceipt.bankName; //银行名称
                        this.form.bankBranchName =
                            res.data.propertyReceipt.bankBranchName; //银行名称
                        //step2
                        this.form.makeDate = res.data.contract.makeDate; //交房日期
                        this.form.activeDate = res.data.contract.activeDate; //生效日期
                        this.form.startDate = res.data.contract.startDate; //开始日期
                        this.form.leaseYear = res.data.contract.leaseYear; //租期年
                        this.form.leaseMonth = res.data.contract.leaseMonth; //租期月
                        this.form.endDate = res.data.contract.endDate; //结束日期
                        this.form.guaranteedDate =
                            res.data.contract.guaranteedDate; //保底出租日期
                        this.form.deposit = res.data.contract.deposit; //押金
                        this.form.agentFee = res.data.contract.agentFee; //中介费
                        this.form.awardFee = res.data.contract.awardFee; //经纪人奖励
                        this.form.referencePrice =
                            res.data.contract.referencePrice; //参考租金价格
                        this.form.houseRoomPriceList =
                            res.data.houseRoomPriceList; //出租价格
                        //包租
                        this.form.freeType = res.data.contract.freeType; //免租方式
                        this.form.propertyContractRentPeriodList =
                            res.data.propertyContractRentPeriodList || []; //每年约定租期
                        this.form.freeTotalDays =
                            res.data.contract.freeTotalDays; //免租总天数
                        this.form.payMonth = res.data.contract.payMonth; //付几
                        this.form.depositMonth = res.data.contract.depositMonth; //押几
                        //step3
                        this.form.materials = res.data.materials; //资产
                         this.form.unuseAssetsIdList = res.data.unuseMaterials || [],
                        //step4
                        this.form.electricTotal =
                            res.data.contract.electricTotal; //电总
                        this.form.electricMax = res.data.contract.electricMax; //电峰
                        this.form.electricMin = res.data.contract.electricMin; //电谷
                        this.form.water = res.data.contract.water; //水
                        this.form.gas = res.data.contract.gas; //燃气
                        this.form.electricCard = res.data.contract.electricCard;
                        this.form.waterCard = res.data.contract.waterCard;
                        this.form.gasCard = res.data.contract.gasCard;
                        if (res.data.image) {
                            this.form.idCardFrontUrl =
                                res.data.image.idCardFront + `${isAddTextMask?imgMaskUrl:''}`; //身份证正面
                            this.form.idCardBackUrl = res.data.image.idCardBack + `${isAddTextMask?imgMaskUrl:''}`; //身份证反面
                            this.form.electricTotalUrl =
                                res.data.image.electricTotal; //电总图
                            this.form.electricMaxUrl =
                                res.data.image.electricMax; //电峰图
                            this.form.electricMinUrl =
                                res.data.image.electricMin; //电谷图
                            this.form.waterUrl = res.data.image.water; //水图
                            this.form.gasUrl = res.data.image.gas; //燃气图
                            this.form.videoUrl = res.data.image.video; //视频
                            this.playerOptions.sources[0].src =
                                res.data.image.video;
                            this.form.cardUrl = res.data.image.bankCard; //银行卡图
                            this.form.contactUrl = res.data.image.contact
                                ? res.data.image.contact.toString()
                                : ""; //合约图
                            this.form.propertyUrl = res.data.image.property
                                ? res.data.image.property.toString()
                                : ""; //产权图
                            this.form.otherUrl = res.data.image.other
                                ? res.data.image.other.toString()
                                : ""; //其它图
                        }
                        this.form.propertyFileType =
                            res.data.contract.propertyFileType; //产权证明文件类型
                        this.form.propertyFileNo =
                            res.data.contract.propertyFileNo; //产权证明文件编码
                        this.form.otherPropertyType =
                            res.data.contract.otherPropertyType; //其他产权证明类型说明
                        this.form.equityType = res.data.contract.equityType,//产权性质
                        this.form.equityIdType = res.data.contract.equityIdType,//产权人证件类型
                        this.form.equityIdNo = res.data.contract.equityIdNo,//产权人证件号
                        this.form.located = res.data.contract.located,//坐落
                        this.form.purpose = res.data.contract.purpose,//用途
                        this.form.rentPurpose = res.data.contract.rentPurpose,//租赁用途    
                        this.form.qiuQuanNo = res.data.contract.qiuQuanNo; //丘权号
                        this.form.propertyOwner =
                            res.data.contract.propertyOwner; //产权人
                        this.form.settleElectricMax =
                            res.data.contract.settleElectricMax;
                        this.form.settleElectricMin =
                            res.data.contract.settleElectricMin;
                        this.form.settleElectricTotal =
                            res.data.contract.settleElectricTotal;
                        this.form.settleWater = res.data.contract.settleWater;
                        this.form.settleGas = res.data.contract.settleGas;
                        this.form.arrearWater = res.data.contract.arrearWater;
                        this.form.arrearElectricMax =
                            res.data.contract.arrearElectricMax;
                        this.form.arrearElectricMin =
                            res.data.contract.arrearElectricMin;
                        this.form.arrearElectricTotal =
                            res.data.contract.arrearElectricTotal;
                        this.form.arrearGas = res.data.contract.arrearGas;
                        this.form.shareBillPerMonth =
                            res.data.contract.shareBillPerMonth;
                        this.form.settleDate = res.data.contract.settleDate;
                        this.form.totalArrear = res.data.contract.totalArrear;
                        this.form.remarks = res.data.contract.remarks.length
                        ? (type == 2 ? ["", "", "", ""]:res.data.contract.remarks)
                        : ["", "", "", ""], //备注
                        //水电燃度数
                        this.houseDegrees = {
                            lastElectricMax: res.data.house.lastElectricMax / 1,
                            lastElectricMin: res.data.house.lastElectricMin / 1,
                            lastElectricTotal:
                                res.data.house.lastElectricTotal / 1,
                            lastGas: res.data.house.lastGas / 1,
                            lastWater: res.data.house.lastWater / 1,
                        };
                        this.getReceiptList();
                        resolve(true);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //第一步
        //搜索房源
        onSearchHouse() {
            if (!this.searchValueHouse) return;
            this.searchLoad = true;
            this.houseList = [];
            requestFssHouseList({ address: this.searchValueHouse }).then(
                (res) => {
                    this.searchLoad = false;
                    this.houseList = res.data || [];
                }
            );
        },
        //搜索取消
        onCancel() {
            this.showHouse = false;
            this.showProperty = false;
            this.showReceipt = false;
        },
       
        //选择房源
        changeHouse(item) {
            this.houseNow = item;
            requestHouseContract(item.id)
                .then(async (res) => {
                    if (res.data) {
                        //有未走完流程合约
                        await this.getDetail(res.data);
                        this.showHouse = false;
                    } else {
                        //没有签过
                        this.form.houseId = item.id;
                        this.showHouse = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //切换承租方式
        changeTenantType(tenantType) {
            if (this.form.tenantType == tenantType) {
                return;
            }
            this.form.activeDate = ""; //生效日期
            this.form.startDate = ""; //开始日期
            this.form.leaseYear = ""; //租期年
            this.form.leaseMonth = ""; //租期月
            this.form.endDate = ""; //结束日期
            this.form.guaranteedDate = ""; //保底出租日期
            this.form.deposit = ""; //押金
            this.form.referencePrice = ""; //参考租金价格
            this.form.freeType = ""; //免租方式
            this.form.propertyContractRentPeriodList = []; //每年约定租期
            this.form.freeTotalDays = 0; //免租总天数
            this.form.payMonth = ""; //付几
            this.form.depositMonth = ""; //押几
            this.form.tenantType = tenantType;
        },
        //搜索业主
        onSearchProperty() {
            if (!this.searchValueProperty) return;
            this.searchLoad = true;
            this.propertyList = [];
            requestPhoneList({
                phone: this.searchValueProperty,
            })
                .then((res) => {
                    this.searchLoad = false;
                    this.propertyList = res.data;
                })
                .catch((err) => {
                    this.searchLoad = false;
                });
        },
        //选择业主
        changeProperty(item) {
            this.receipt = "";
            this.receiptOld = "";
            this.form.payType = ""; //支付方式
            this.form.bankAccount = ""; //收款账号
            this.form.accountName = ""; //收款人姓名
            this.form.bankName = ""; //银行名称
            this.form.bankBranchName = ""; //支行名称

            this.propertyNow = item;
            this.form.propertyId = item.id;
            this.form.propertyPhone = item.phone;
            this.form.propertyName = item.name;
            this.form.idType = item.idType;
            this.form.idNo = item.idNo;
            this.form.contactName = item.contactName;
            this.form.contactRelation = item.contactRelation;
            this.form.contactPhone = item.contactPhone;
            this.showProperty = false;
        },
        changeAccount(item) {
            this.form.payType = "";
            this.form.propertyReceiptId = "";
            this.form.bankAccount = "";
            this.form.accountName = "";
            this.form.bankName = "";
            this.form.bankBranchName = "";
        },
        //切换支付方式
        changePay(item, index) {
            this.form.payType = index / 1 + 1;
            this.showPayType = false;
            this.form.propertyReceiptId = "";
            this.form.bankAccount = "";
            this.form.accountName = "";
            this.form.bankName = "";
            this.form.bankBranchName = "";
        },
        //获取收款账号
        getReceiptList() {
            if (!this.form.propertyId || !this.form.payType) {
                return;
            }
            let param = {
                propertyId: this.form.propertyId,
                payType: this.form.payType,
            };
            requestPReceipt(param).then((res) => {
                this.receiptList = res.data;
            });
        },
        //获取开户行
        getBankList() {
            requestBankSelect().then((res) => {
                this.bankList = res.data || [];
            });
        },
        //切换收款账号
        changeReceipt(item) {
            this.receiptNow = item;
            this.form.propertyReceiptId = item.id;
            this.form.bankAccount = item.bankAccount;
            this.form.accountName = item.accountName;
            this.form.bankName = item.bankName;
            this.form.bankBranchName = item.bankBranchName;
            this.showReceipt = false;
            // this.form.propertyId = item.id;
        },
        clearContactRelation(){
            console.log("adc")
            this.form.contactRelation = ""
        },
        next1() {
          this.$refs.form1.validate().then(valid => {
                this.form.operationNo = this.active / 1 + 1;
                this.form.type = this.form.type ? this.form.type : "1"; //1：新签，2：续签，3：换房，4：转租
                this.saveLoad = true;
                requestFssContractCreate(this.form)
                    .then(res => {
                        this.getDetail(res.data);
                        this.active = 1;
                        this.saveLoad = false;
                    })
                    .catch(err => {
                        this.saveLoad = false;
                    });
            });
        },

        //第二步
        //交房日期确定
       getUnuseAssetsIdList(){
            requestUnuseAssetsIdList(this.form.houseId).then(res=>{
                this.unuseAssetsIdListData = res.data
            })
       },
       changeUnuseAssets(e){
           console.log(e)
            this.form.unuseAssetsIdList = e
       },
        makeDateConfirm(val) {
            this.form.makeDate = formatDate(val) + " 00:00:00";
            this.showMakeDate = false;
            this.$refs.form2.validate("startDate");
            this.$refs.form2.validate("guaranteedDate");
            this.$refs.form2.validate("activeDate");
        },
        //包租
        //生效日期确定
        activeDateConfirm(val) {
            this.form.activeDate = formatDate(val) + " 00:00:00";
            this.showActiveDate = false;
            this.changeRentList();
            this.$refs.form2.validate("activeDate");
        },
        //计算押金
        changePrice() {
            if (this.form.depositMonth == 0) {
                this.form.deposit = 0;
            }
            if (
                !this.form.propertyContractRentPeriodList[0] ||
                !this.form.depositMonth
            )
                return;
            this.form.deposit = accMul(
                this.form.propertyContractRentPeriodList[0].monthPrice,
                this.form.depositMonth
            );
        },
        //计算免租期
        //计算租期表格
        changeRentList() {
            this.form.freeTotalDays = 0; //免租总天数
            if (
                (!this.form.leaseYear && !this.form.leaseMonth) ||
                !this.form.activeDate ||
                !this.form.freeType
            )
                return;
            let rentPeriodList = [],
                sum =
                    this.form.leaseYear / 1 +
                    (this.form.leaseMonth / 1 ? 1 : 0); //遍历次数
            //前置免租期
            for (let i = 0; i < sum; i++) {
                let startDate =
                    i == 0
                        ? this.form.activeDate.slice(0, 10)
                        : getNdaysDate(rentPeriodList[i - 1].endDate, 1);
                let endDate =
                    this.form.leaseMonth / 1 &&
                    ((i == 0 && sum == 1) || (i == sum - 1 && sum > 1))
                        ? getEndDate(
                              new Date(startDate.replace(/-/g, "/")),
                              0,
                              this.form.leaseMonth,
                              0
                          )
                        : getEndDate(
                              new Date(startDate.replace(/-/g, "/")),
                              1,
                              0,
                              0
                          );
                let maxDays =
                    (Date.parse(endDate) - Date.parse(startDate)) /
                        (1000 * 60 * 60 * 24) +
                    1;
                let obj = {
                    no: i + 1,
                    freeDays: 0,
                    maxDays: maxDays,
                    startDate: startDate + " 00:00:00",
                    endDate: endDate + " 00:00:00",
                    startOldDate: startDate + " 00:00:00",
                    endOldDate: endDate + " 00:00:00",
                    monthPrice: "",
                };
                rentPeriodList.push(obj);
            }
            this.form.propertyContractRentPeriodList = rentPeriodList;
            if (rentPeriodList.length) {
                this.form.startDate = rentPeriodList[0].startDate;
                this.form.endDate =
                    rentPeriodList[rentPeriodList.length - 1].endDate;
            }
        },
        changeFreeDays(index, item) {
            if (this.form.freeType == 1) {
                //内置免租期

                //计算免租总天数
                this.form.freeTotalDays = this.form.propertyContractRentPeriodList.reduce(
                    (total, e) => {
                        return accAdd(total, e.freeDays);
                    },
                    0
                );
                //计算合约开始付租时间，结束时间
                this.form.startDate = this.form.propertyContractRentPeriodList[0].startDate;
                this.form.endDate = this.form.propertyContractRentPeriodList[
                    this.form.propertyContractRentPeriodList.length - 1
                ].endDate;
                if (item.freeDays > item.maxDays) {
                    this.$toast.fail("免租天数不得大于当年天数" + item.maxDays);
                } else if (item.freeDays == item.maxDays) {
                    item.monthPrice = 0;
                }
                return;
            }
            //计算表格
            for (
                let i = index;
                i < this.form.propertyContractRentPeriodList.length;
                i++
            ) {
                const element = this.form.propertyContractRentPeriodList[i];
                if (i == 0) {
                    element.startDate =
                        getNdaysDate(element.startOldDate, item.freeDays) +
                        " 00:00:00";
                    element.endDate =
                        this.form.leaseYear / 1
                            ? getEndDate(
                                  new Date(
                                      element.startDate.replace(/-/g, "/")
                                  ),
                                  1,
                                  0,
                                  0
                              ) + " 00:00:00"
                            : getEndDate(
                                  new Date(
                                      element.startDate.replace(/-/g, "/")
                                  ),
                                  0,
                                  this.form.leaseMonth,
                                  0
                              ) + " 00:00:00";
                } else {
                    const elementPrev = this.form
                        .propertyContractRentPeriodList[i - 1];
                    element.startDate =
                        getNdaysDate(
                            elementPrev.endDate,
                            1 + element.freeDays / 1
                        ) + " 00:00:00";
                    element.endDate =
                        i ==
                            this.form.propertyContractRentPeriodList.length -
                                1 && this.form.leaseMonth / 1
                            ? getEndDate(
                                  new Date(
                                      element.startDate.replace(/-/g, "/")
                                  ),
                                  0,
                                  this.form.leaseMonth,
                                  0
                              ) + " 00:00:00"
                            : getEndDate(
                                  new Date(
                                      element.startDate.replace(/-/g, "/")
                                  ),
                                  1,
                                  0,
                                  0
                              ) + " 00:00:00";
                }
            }
            //计算免租总天数
            this.form.freeTotalDays = this.form.propertyContractRentPeriodList.reduce(
                (total, e) => {
                    return accAdd(total, e.freeDays);
                },
                0
            );
            //计算合约开始付租时间，结束时间
            this.form.startDate = this.form.propertyContractRentPeriodList[0].startDate;
            this.form.endDate = this.form.propertyContractRentPeriodList[
                this.form.propertyContractRentPeriodList.length - 1
            ].endDate;
        },
        //托管
        //开始日期
        startDateConfirm(val) {
            this.form.startDate = formatDate(val) + " 00:00:00";
            this.showStartDate = false;
            if (this.form.leaseYear || this.form.leaseMonth) {
                this.getEndDate();
            }
            this.$refs.form2.validate("startDate");
        },
        //保底出租日期
        guaranteedDateConfirm(val) {
            this.form.guaranteedDate = formatDate(val) + " 00:00:00";
            this.showGuaranteedDate = false;
            this.$refs.form2.validate("guaranteedDate");
        },
        //计算结束日期
        getEndDate() {
            let endDate = getEndDate(
                this.form.startDate ? this.form.startDate.slice(0, 10) : "",
                this.form.leaseYear,
                this.form.leaseMonth,
                0
            );
            this.form.endDate = endDate + " 00:00:00";
        },
        //计算整租价格
        getAllPrice(item) {
            if (item.roomNo) {
                let last = this.form.houseRoomPriceList.length - 1;
                this.form.houseRoomPriceList[last].price = 0;
                for (
                    let i = 0;
                    i < this.form.houseRoomPriceList.length - 1;
                    i++
                ) {
                    const element = this.form.houseRoomPriceList[i];
                    this.form.houseRoomPriceList[last].price = accAdd(
                        this.form.houseRoomPriceList[last].price,
                        element.price
                    );
                }
            }
            return;
        },
        next2() {
            this.$refs.form2.validate().then((valid) => {
                for (
                    let index = 0;
                    index < this.form.propertyContractRentPeriodList.length;
                    index++
                ) {
                    const element = this.form.propertyContractRentPeriodList[
                        index
                    ];
                    if (
                        element.freeDays > element.maxDays &&
                        this.form.freeType == 1
                    ) {
                        this.$toast.fail(
                            "免租天数不得大于当年天数" + element.maxDays
                        );
                        return;
                    }
                    if (!element.freeDays) {
                        element.freeDays = 0;
                    }
                    if (!element.monthPrice && element.monthPrice !== 0) {
                        this.$toast.fail("请输入每年约定的月租金", "fail");
                        this.ruleErr = true;
                        return;
                    }
                    if (!validNum0Decimal2(element.monthPrice)) {
                        this.$toast.fail(
                            "每年约定的月租金最多保留两位小数",
                            "fail"
                        );
                        this.ruleErr = true;
                        return;
                    }
                }
                this.form.operationNo = this.active / 1 + 1; //第几步
                this.saveLoad = true;
                requestFssContractCreate(this.form)
                    .then((res) => {
                        this.getDetail(res.data);
                        this.active = 2;
                        this.saveLoad = false;
                    })
                    .catch((err) => {
                        this.saveLoad = false;
                    });
            });
        },

        //第三步
        //数量减
        assetsReduce(index, rowIndex) {
            if (this.form.materials[index].materials[rowIndex].count > 1) {
                this.form.materials[index].materials[rowIndex].count--;
            } else {
                return;
            }
        },
        //数量加
        assetsAdd(index, rowIndex) {
            this.form.materials[index].materials[rowIndex].count++;
        },
        //删除已添加
        assetsDelete(index, rowIndex) {
            this.form.materials[index].materials.splice(rowIndex, 1);
        },
        // ---物料库---
        //资产分页
        getAsstesList() {
            this.assetsLoading = true;
            requestMaterialList(this.assetsSearchQuery).then((res) => {
                this.assetsList = [
                    ...this.assetsList,
                    ...(res.data.records || []),
                ];
                this.assetsLoading = false;
                if (res.data.current == res.data.pages || !res.data.pages) {
                    this.assetsFinished = true;
                }
            });
        },
        //物料一confirm
        materialTypeConfirm1(item, index) {
            this.materialTypeName = item.name;
            this.childTypeName = "";
            this.materialTypeList2 = item.childList;
            this.showMaterialType1 = false;
            this.assetsSearchQuery.materialTypeId = item.id;
            this.assetsSearchQuery.childTypeId = "";
            this.assetsSearchQuery.pageNumber = 1;
            this.assetsList = [];
            this.assetsFinished = false;
            this.getAsstesList();
        },
        //物料二confirm
        materialTypeConfirm2(item, index) {
            this.childTypeName = item.name;
            this.showMaterialType2 = false;
            this.assetsSearchQuery.childTypeId = item.id;
            this.assetsSearchQuery.pageNumber = 1;
            this.assetsList = [];
            this.assetsFinished = false;
            this.getAsstesList();
        },
        //物料品类
        getMaterialTypeTree() {
            requestMaterialTypeTree().then((res) => {
                res.data.unshift({
                    name: "全部",
                    id: "",
                    childList: [],
                });
                this.materialTypeList11 = res.data || [];
                res.data.forEach((d) => {
                    d.childList.unshift({
                        name: "全部",
                        id: "",
                    });
                });
                this.materialTypeList1 = res.data || [];
            });
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        assetsOnLoad() {
            this.assetsSearchQuery.pageNumber++;
            this.getAsstesList();
        },
        //---自定义---
        //物料一confirm
        materialTypeConfirm11(item, index) {
            this.assetsQuery.materialTypeParentId = item.id;
            this.assetsQuery.materialTypeParentName = item.name;
            this.assetsQuery.materialTypeId = "";
            this.assetsQuery.materialTypeName = "";
            this.showMaterialType11 = false;
            if (item.id) {
                requestMaterialChild(item.id).then((res) => {
                    this.materialTypeList22 = res.data || [];
                });
            }
        },
        //物料二confirm
        materialTypeConfirm22(item, index) {
            this.assetsQuery.materialTypeId = item.id;
            this.assetsQuery.materialTypeName = item.name;
            this.assetsQuery.specification = "";
            this.showMaterialType22 = false;
            requestMaterialChild3(item.id).then((res) => {
                this.materialTypeList33 = res.data || [];
            });
        },
        showAssatsAdd(index) {
            this.showAssets = true;
            this.nowRoom = index;
            this.assetsSearchQuery = {
                materialTypeId: "",
                childTypeId: "",
                pageNumber: 1,
                pageSize: 20,
            };
            this.getMaterialTypeTree();
            this.getAsstesList();
        },
        assetsConfirm() {
            if (this.assetsActive == 0) {
                if (this.assetsChecked.length == 0) {
                    this.$toast.fail("请先选择资产！");
                    return;
                }
                this.assetsChecked.forEach((d) => {
                    let has = true;
                    this.form.materials[this.nowRoom].materials.forEach((e) => {
                        if (d.id == e.id) {
                            has = false;
                            e.count++;
                        }
                    });
                    if (has) {
                        d.count = 1;
                        console.log(d);
                        let p = {
                            brand: d.brand,
                            count: d.count,
                            id: d.id,
                            materialTypeName: d.materialName,
                            materialTypeParentName: d.materialType,
                            materialTypeId: d.materialTypeId,
                            materialTypeParentId: d.materialTypeParentId,
                            model: d.model,
                            price: d.price,
                            specification: d.specification,
                        };
                        this.form.materials[this.nowRoom].materials.push(p);
                    }
                });
                this.showAssets = false;
            } else {
                this.$refs.formAssets.validate().then((valid) => {
                    this.assetsQuery.count = 1;
                    this.form.materials[this.nowRoom].materials = JSON.parse(
                        JSON.stringify([
                            ...this.form.materials[this.nowRoom].materials,
                            ...[this.assetsQuery],
                        ])
                    );
                    this.showAssets = false;
                });
            }
        },
        assetsCancel() {
            this.showAssets = false;
        },
        next3() {
            this.form.operationNo = this.active / 1 + 1; //第几步
            this.form.materials.forEach((d) => {
                d.houseId = this.form.houseId;
                d.materials.forEach((e) => {
                    e.materialId = e.id;
                });
            });
            this.saveLoad = true;
            requestFssContractCreate(this.form)
                .then((res) => {
                    this.getDetail(res.data);
                    this.active = 3;
                    this.saveLoad = false;
                })
                .catch((err) => {
                    this.saveLoad = false;
                });
        },
        //第四步
        //获取七牛token
        getQiniuToken() {
            requestQiniuToken()
                .then((res) => {
                    this.qiniuData.token = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //图片上传前校验，压缩
        beforeRead(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isLt8M = file.size / 1024 / 1024 < 8;
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isJPG && !isPNG) {
                this.$toast.fail("图片只能是 JPG/PNG 格式！");
                return false;
            }
            if (!isLt10M) {
                this.$toast.fail("图片大小不能超过 10MB!");
                return false;
            }
            this.qiniuData.key = Date.now() + file.name;
            return new Promise((resolve, reject) => {
                compressAccurately(file, 400).then((fileMin) => {
                    let data = new FormData();
                    data.append("token", this.qiniuData.token);
                    data.append("key", this.qiniuData.key);
                    data.append("file", fileMin);
                    request({
                        url: this.$store.state.qiniuUpload,
                        method: "post",
                        processData: false,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        data: data,
                    })
                        .then((res) => {
                            let newFile = fileMin;
                            newFile.key = res.key;
                            resolve(newFile);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                });
            });
        },
        //视频上传前处理
        beforeReadVideo(file) {
            console.log(file);
            this.qiniuData.key = Date.now() + file.name;
            const isLt20M = file.size / 1024 / 1024 < 20;
            // if (!isLt20M) {
            //     this.$toast.fail("视频大小不能超过 20MB!");
            //     return false;
            // }
            this.videoUrl = [
                {
                    status: "uploading",
                },
            ];
            return new Promise((resolve, reject) => {
                let data = new FormData();
                data.append("token", this.qiniuData.token);
                data.append("key", this.qiniuData.key);
                data.append("file", file);
                request({
                    url: this.$store.state.qiniuUpload,
                    method: "post",
                    processData: false,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: data,
                })
                    .then((res) => {
                        let newFile = file;
                        newFile.key = res.key;
                        resolve(newFile);
                    })
                    .catch((err) => {
                        this.videoUrl = [
                            {
                                status: "failed",
                            },
                        ];
                        reject(err);
                    });
            });
        },
        //视频播放
        videoStart() {
            const player = this.$refs.videoPlayer.player;
            player.requestFullscreen(); //调用全屏api方法
            player.isFullscreen(true);
            player.play();
        },
        next4() {
            console.log(this.form)
            if (this.saveLoad) return;
            this.$refs.form4.validate().then((valid) => {
                this.form.operationNo = this.active / 1 + 1; //第几步
                //图片参数格式
                if (this.imgUp) {
                    this.form.idCardFrontUrl = this.idCardFrontUrl.length
                        ? (isAddTextMask?this.idCardFrontUrl[0].url.replace(imgMaskUrl, ""):this.idCardFrontUrl[0].url)
                        : ""; //签约人身份证正面
                    this.form.idCardBackUrl = this.idCardBackUrl.length
                        ? (isAddTextMask?this.idCardBackUrl[0].url.replace(imgMaskUrl, ""):this.idCardBackUrl[0].url)
                        : ""; //签约人身份证反面
                    this.form.electricTotalUrl = this.electricTotalUrl[0]
                        ? this.electricTotalUrl[0].url
                        : ""; //电总
                    this.form.electricMaxUrl = this.electricMaxUrl[0]
                        ? this.electricMaxUrl[0].url
                        : ""; //电峰
                    this.form.electricMinUrl = this.electricMinUrl[0]
                        ? this.electricMinUrl[0].url
                        : ""; //电谷
                    this.form.waterUrl = this.waterUrl[0]
                        ? this.waterUrl[0].url
                        : ""; //水
                    this.form.gasUrl = this.gasUrl[0] ? this.gasUrl[0].url : ""; //燃气
                    this.form.cardUrl = this.cardUrl[0]
                        ? this.cardUrl[0].url
                        : ""; //银行卡
                    let contactUrl = []; //合同
                    if (this.contactUrl) {
                        this.contactUrl.forEach((d) => {
                            if(isAddTextMask &&d.url.indexOf('watermark')>-1){
                                let url = d.url.replace(imgMaskUrl, "")
                                contactUrl.push(url)
                                return
                            }
                            contactUrl.push(d.url);
                        });
                    }
                    this.form.contactUrl = contactUrl.join(";");
                    let propertyUrl = []; //产权
                    if (this.propertyUrl) {
                        this.propertyUrl.forEach((d) => {
                            if(isAddTextMask &&d.url.indexOf('watermark')>-1){
                                let url = d.url.replace(imgMaskUrl, "")
                                propertyUrl.push(url)
                                return
                            }
                            propertyUrl.push(d.url);
                        });
                    }
                    this.form.propertyUrl = propertyUrl.join(";");
                    let otherUrl = []; //其他
                    if (this.otherUrl) {
                        this.otherUrl.forEach((d) => {
                            otherUrl.push(d.url);
                        });
                    }
                    this.form.otherUrl = otherUrl.join(";");
                    this.form.videoUrl = this.videoUrl.length
                        ? this.videoUrl[0].url
                        : ""; //视频
                }
                this.saveLoad = true;
                if(this.form.tenantType != 2){
                    requestFssContractCreate(this.form)
                    .then((res) => {
                        this.getDetail(res.data);
                        this.getJointOrderList(this.form.contractId)
                        // this.active = 4;
                    
                        this.saveLoad = false;
                    }) .catch((err) => {
                    this.saveLoad = false;
                });
                }else{
                     requestFssContractCreate(this.form)
                    .then((res) => {
                        this.$toast.success({
                            message: "保存成功",
                            forbidClick: true,
                            onClose: () => {
                                this.$router.back();
                                // this.$router.push({ path: "contractList" });
                            },
                        });
                        this.saveLoad = false;
                    })
                    .catch((err) => {
                        this.saveLoad = false;
                        console.log(err);
                    });
                }
               
              

            });
        },
        getJointOrderList(id){
             requestJointOrderContractConstructDetail(id).then(res=>{
                this.itemList = res.data.itemList;
                this.totalPrice = res.data.totalPrice
                this.active = 4;
                console.log(this.form)
             }).catch(err=>{
                 console.log(err)
             })
        },
        save(){
            requestJointOrderConstructDetailLast(this.form.houseId)
            .then((res) => {
            this.saveLoad = false;
            this.compareData = deepClone(this.itemList);
            console.log(
                this.itemList.some(
                (item) => item.moduleId == 1454997126705213441
                )
            );
            this.constructFilter(this.compareData, res.data);
            for (let k = 0; k < this.itemList.length; k++) {
                if (
                this.itemList[k].count < 0 ||
                !this.itemList[k].priceType ||
                !this.itemList[k].priceUnit
                ) {
                this.$toast(
                    `请完善施工项【${this.itemList[k].projectName}】信息`
                );
                return false;
                }
            }

          if (this.saved) {
            const obj = {};
         this.form.itemList = this.itemList
                         this.form.totalPrice = this.totalPrice
                         this.form.operationNo = this.active / 1 + 1;
               requestFssContractCreate(this.form)
                    .then((res) => {
                        this.$toast.success({
                            message: "保存成功",
                            forbidClick: true,
                            onClose: () => {
                                this.$router.back();
                                // this.$router.push({ path: "contractList" });
                            },
                        });
                        this.saveLoad = false;
                    })
                    .catch((err) => {
                        this.saveLoad = false;
                        console.log(err);
                    });
        
          }
        })
        .catch((err) => {
          this.saveLoad = false;
        });
        },
        tip(addList, deleteList, changeNew, changeOld) {
            console.log(addList, deleteList, changeNew, changeOld)
            if (
                addList.length ||
                deleteList.length ||
                changeNew.length ||
                changeOld.length
            ) {
            var message = "";
            for (let key of addList) {
            message += `增加施工项【${key.projectName}】\n`;
            }
            for (let key of deleteList) {
            message += `施工项【${key.projectName}】已移除\n`;
            }
            console.log(changeNew, changeOld);
            changeOld.forEach((item, index) => {
            // console.log(item)
            if (
                item.priceType == 1 &&
                item.price != changeNew[index].addPrice
            ) {
                message += `施工项【${item.projectName}】单价调整为${changeNew[index].addPrice}\n`;
            }
            if (
                item.priceType == 2 &&
                item.price != changeNew[index].repairPrice
            ) {
                message += `施工项【${item.projectName}】单价调整为${changeNew[index].repairPrice}\n`;
            }
            });
            // console.log(message)
            if (message.length > 0) {
            this.$dialog
                .alert({
                title: "提示",
                message,
                })
                .then(() => {});
            } else {
            this.saved = true;
            }
        } else {
            this.saved = true;
        }
        },
        constructFilter(oldList, newList) {
        let oldData = oldList.map((item) => {
            return {
            moduleId: item.moduleId,
            projectName: item.projectName,
            price: item.price,
            };
        });
        let newData = newList.map((item) => {
            return {
            moduleId: item.moduleId,
            projectName: item.projectName,
            price: item.price,
            };
        });
        let oldArr = [];
        let newArr = [];
        for (let i = 0; i < oldList.length; i++) {
            oldArr.push(oldList[i].moduleId);
        }
        for (let i = 0; i < newList.length; i++) {
            newArr.push(newList[i].moduleId);
        }
        let addArr = this._.difference(newArr, oldArr);
        let deleteArr = this._.difference(oldArr, newArr);
        //   console.log(addArr);
        let testarr = [];
        let testarr2 = [];
        let changeNewData = [];
        let changeOldData = [];
        if (addArr.length) {
            // 新增施工项渲染到列表
            for (let i = 0; i < addArr.length; i++) {
            newList.filter((item) => {
                if (item.moduleId == addArr[i]) {
                console.log(this.decorationType);
                if (this.decorationType == 1) {
                    item.price = item.addPrice;
                    item.priceType = 1;
                } else {
                    item.price = "";
                }
                item.count = 0;
                testarr.push(item);
                console.log(item);

                this.itemList.unshift(item);
                }
            });
            }
        }
        if (deleteArr.length) {
            //移除被删除的施工项
            for (let i = 0; i < deleteArr.length; i++) {
            oldList.filter((item) => {
                if (item.moduleId == deleteArr[i]) {
                testarr2.push(item);
                }
            });
            for (let k = 0; k < this.itemList.length; k++) {
                for (let i = 0; i < deleteArr.length; i++) {
                if (this.itemList[k].moduleId == deleteArr[i]) {
                    this.itemList.splice(k, 1);
                }
                }
            }
            }
        }
        console.log(oldList,1)
        console.log(newList,2)
            //过滤新数组中被修改的施工项
        for (let i = 0; i < oldList.length; i++) {
            for (let k = 0; k < newList.length; k++) {
            if (oldList[i].moduleId == newList[k].moduleId) {
                if(oldList[i].priceType == 1){
                if(oldList[i].price != newList[k].addPrice){
                    changeNewData.push(newList[k]);
                }
                }else{
                        if(oldList[i].price != newList[k].repairPrice){
                        changeNewData.push(newList[k]);
                        }
                }
            }
            }
        } 
        
        for (let i = 0; i < changeNewData.length; i++) {
            oldList.find((item) => {
            if (changeNewData[i].moduleId == item.moduleId) {
                changeOldData.push(item);
            }
            });
        } //旧数组中需要修改的施工项 用于提示
        this.tip(testarr, testarr2, changeNewData, changeOldData);
        // console.log(this.itemList,changeNewData)
        for (let i = 0; i < this.itemList.length; i++) {
            for (let k = 0; k < changeNewData.length; k++) {
            if (this.itemList[i].moduleId == changeNewData[k].moduleId) {
                // console.log("sanme")
                if (this.itemList[i].priceType < 2) {
                // console.log("te")
                this.itemList[i].price = changeNewData[k].addPrice;
                this.itemList[i].addPrice = changeNewData[k].addPrice;
                } else {
                this.itemList[i].price = changeNewData[k].repairPrice;
                this.itemList[i].repairPrice =
                    changeNewData[k].repairPrice;
                }
            }
            }
        }
        },
        construct(item, index) {
        this.index = index;
            console.log(this.itemList[index]);
        this.projectName = this.itemList[index].projectName;
        this.priceType = this.itemList[index].priceType + "";
        this.addPrice = this.itemList[index].addPrice;
        this.repairPrice = this.itemList[index].repairPrice;
        this.count = this.itemList[index].count;
        this.remark = this.itemList[index].remark;
        this.priceUnit = this.itemList[index].priceUnit;
        this.price = this.itemList[index].price;
        // console.log(this.priceType)
        if (this.priceType == 1) {
            this.danjia =
            this.itemList[index].addPrice +
            this.itemList[index].priceUnit;
        } else if (this.priceType == 2) {
            this.danjia =
            this.itemList[index].repairPrice +
            this.itemList[index].priceUnit;
        } else {
            this.priceType = null;
            this.danjia = "";
        }
        //  if ( this.priceType == 'null') {
        //   // //    this.addPrice = ''
        //   // //    this.repairPrice = ''

        // } else
        // console.log(this.danjia)
        //   console.log(this.priceType)
        //   if(this.priceType<2){
        //       this.danjia = this.addPrice +
        //         " " +
        //         this.itemList[this.index].priceUnit
        //   }
        this.showEdit = true;
        },
        onSubmitForm() {
        // console.log(this.priceType)
        if (this.priceType == null || this.priceType == "") {
            this.$toast("请选择施工项类型");
            return false;
        }
        this.itemList[this.index].price = this.price;
        this.itemList[this.index].projectName = this.projectName;
        this.itemList[this.index].priceType = this.priceType;
        this.itemList[this.index].addPrice = this.addPrice;
        this.itemList[this.index].repairPrice = this.repairPrice;
        this.itemList[this.index].count = this.count;
        this.itemList[this.index].remark = this.remark;
        this.itemList[this.index].priceUnit = this.priceUnit;
        // console.log(this.itemList);
        this.showEdit = false;
        },
        cancel() {
            this.showEdit = false;
            this.priceType = null;
            this.count = "";
            this.remark = "";
            // console.log(this.itemList);
            return false;
        },
        radioChange(e) {
        //   console.log(e)
            this.priceType = e;
            if (this.priceType) {
                if (this.priceType < 2) {
                this.danjia = this.addPrice + " " + this.priceUnit;
                this.price = this.addPrice 
                } else {
                this.danjia = this.repairPrice + " " + this.priceUnit;
                this.price = this.repairPrice 
                }
            }
        },
        accAdd(num1, num2) {
            if (num1 && num2) {
                return accAdd(num1, num2);
            } else {
                return;
            }
        },
        //校验
        validTenantType() {
            return Boolean(this.form.tenantType);
        },
        validPhone(val) {
            if (!val) {
                return true;
            }
            return validPhone(val);
        },
        validEmail(val) {
            return val ? validEmail(val) : true;
        },
        validIdNo1(val) {
            if (this.form.idType == 1) {
                return validIdNo(val);
            } else {
                return true;
            }
        },
        validIdNoForEquityIdNo(val) {
            if (this.form.equityIdType == 1) {
                return validIdNo(val);
            } else {
                return true;
            }
        },
        validIdNo(val) {
            return validIdNo(val);
        },
        validNum0(val) {
            return validNum0(val);
        },
        //预缴费校验
        advanceFeeValid(val) {
            if (this.form.rentType == 1) {
                //合租不可为0
                return validNum100(val);
            } else {
                //整租
                return val === 0 || val === "0" || validNum100(val);
            }
        },
        //正数或0，最多保留两位小数
        validNum0Decimal2(val) {
            return validNum0Decimal2(val);
        },
        formatDate(val) {
            return formatDate(val);
        },
        formatNumber(val) {
            return val.replace(/[^0-9]/g, "");
        },
        validDeposit(val){
            console.log(val)
             if(this.form.tenantType != 2){
                 if (
                  val <
                  accMul(
                    this.form.propertyContractRentPeriodList[0].monthPrice,
                    this.form.depositMonth
                  )
                ){
                    return false
                }
             }
        }
    },
    watch: {
        active(nowData) {
            this.activeMax =
                nowData > this.activeMax ? nowData : this.activeMax;
        },
        showAssets(nowData) {
            if (!nowData) {
                this.assetsActive = 0;
                //物料
                this.assetsLoading = false;
                this.assetsFinished = false;
                this.materialTypeName = "";
                this.childTypeName = "";
                this.assetsSearchQuery = {
                    materialTypeId: "",
                    childTypeId: "",
                    pageNumber: 1,
                    pageSize: 20,
                };
                this.assetsList = [];
                this.assetsChecked = [];
                this.nowRoom = "";
                this.showRoom = false;
                this.showMaterialType1 = false;
                this.materialTypeList1 = [];
                this.showMaterialType2 = false;
                this.materialTypeList2 = [];
                //自定义资产
                this.assetsQuery = {
                    materialTypeParentId: "",
                    materialTypeParentName: "",
                    materialTypeId: "",
                    materialTypeName: "",
                    specification: "",
                    brand: "",
                    model: "",
                    price: "",
                };
                this.showMaterialType11 = false;
                this.materialTypeList11 = [];
                this.showMaterialType22 = false;
                this.materialTypeList22 = [];
                this.showMaterialType33 = false;
                this.materialTypeList33 = [];
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#fssContractAdd {
    height: 100%;
}
.field {
    padding: 0.26667rem 0.42667rem;
    background: #fff;
    font-size: 0.32rem;
    line-height: 0.64rem;
    color: #000;
    text-align: left;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
    .button-mini {
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        display: inline-block;
        text-align: center;
        border: 1px solid #a2a2a2;
        border-radius: 0.1rem;
        vertical-align: middle;
    }
}
.sub {
    position: relative;
    width: 0.5rem;
    height: 0.5rem;
    background-color: transparent;
    outline: none;
    border: 1px solid #a2a2a2;
    border-radius: 0.1rem;
    vertical-align: middle;
    &::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        background-color: currentColor;
        content: "";
        height: 0.04rem;
        width: 80%;
        color: #a2a2a2;
    }
}
.add {
    position: relative;
    width: 0.5rem;
    height: 0.5rem;
    background-color: transparent;
    outline: none;
    border: 1px solid #a2a2a2;
    border-radius: 0.1rem;
    vertical-align: middle;
    &::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        background-color: currentColor;
        content: "";
        height: 0.04rem;
        width: 80%;
        color: #a2a2a2;
    }
    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        background-color: currentColor;
        content: "";
        height: 80%;
        width: 0.04rem;
        color: #a2a2a2;
    }
}
.unit {
    display: flex;
    padding-right: 0.42rem;
    background: #fff;
    .van-field {
        width: 80%;
        flex: 1;
    }
    .after {
        flex: 0.1;
        padding: 0.26667rem 0;
        line-height: 0.64rem;
    }
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    .van-search {
        /deep/i {
            line-height: 0.84rem;
        }
        /deep/input {
            border: none;
        }
    }
}
.step {
    text-align: left;
}
.form1,
.form2,
.form3,
.form4 {
    height: calc(100vh - 1.8rem);
    overflow: scroll;
    /deep/.preview-cover {
        position: relative;
        width: 3rem;
        height: 3rem;
        background: rgba(0, 0, 0, 1);
        .cover {
            position: absolute;
            z-index: 99;
            width: 100%;
            height: 100%;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        padding: 0%;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
}
.form1 {
    .van-cell.border::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0.42667rem;
        border-bottom: 0.02667rem solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
    /deep/.van-stepper__minus::before,
    /deep/.van-stepper__plus::before {
        height: 2px;
    }
    /deep/.van-stepper__minus::after,
    /deep/.van-stepper__plus::after {
        width: 2px;
    }
}
.form2 {
    .table {
        tr {
            td {
                text-align: center;
                line-height: 0.7rem;
                padding: 0.1rem 0;
            }
        }
        .head {
            font-weight: 600;
            .w15 {
                width: 15%;
            }
        }

        input {
            width: 100%;
            text-align: center;
            border: none;
            background-color: #f9f9f9;
            &:disabled {
                background-color: #f1f1f1;
            }
        }
        position: relative;
        &::after {
            width: 100%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            left: 0;
            bottom: 0;
            border-bottom: 0.02667rem solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
    }
    .error {
        input {
            border: 1px solid #ee0a24;
        }
    }
}
.form3 {
    .title {
        background-color: #fff;
        text-align: left;
        padding: 0.1rem 0.3rem;
        font-size: 0.4rem;
        font-weight: 700;
        color: #000;
        margin-top: 0.3rem;
        .icon {
            font-size: 0.3rem;
            line-height: 0.4rem;
            height: 0.4rem;
            padding: 0;
            vertical-align: middle;
            transform: translateY(-0.04rem);
        }
    }
    .table {
        tr {
            display: flex;
            td {
                line-height: 0.8rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
            }
        }
        .head {
        }
        .body {
            width: 10rem;
            .van-swipe-cell__right {
                button {
                    height: 100%;
                    font-size: 12px;
                }
            }
        }
        .t1 {
            width: 1.5rem;
        }
        .t2 {
            width: 1.5rem;
        }
        .t3 {
            width: 1.5rem;
        }
        .t4 {
            width: 1.5rem;
        }
        .t5 {
            flex: 1;
        }
        .t6 {
            min-width: 1.5rem;
            .iconfont {
                font-size: 0.35rem;
                color: $theme-color;
            }
        }
      
    }
      .assets{
            width:100%;
            overflow:scroll;
            .body{
                    min-width: 100%;
                    //  width: auto;
                width:auto!important;
            }
            
            .t7 {
            width: 1.5rem;
            }  
            .t1{
                width:2.5rem
            }
             .t2{
                width:2.5rem
            }
             .t3{
                width:2.5rem
            }
             .t4{
                width:2.5rem;
                 background: #fff!important;
            }
             .t5{
                width:2.5rem;
                 background: #fff!important;
            }
             .t6{
                width:1.5rem;
                 background: #fff!important;
            }
         .table{
            
             tr{
                 display:table;
                 ;
                 background: #fff!important;
             }
            tr > th:first-child,
            tr > td:first-child {
            position: sticky;
            position: -webkit-sticky;
            left: 0;
            // z-index: 10;
            text-align: center;
            background: #f3f9ff;
            }
             tr > th:last-child,
            tr > td:last-child {
            position: sticky;
            position: -webkit-sticky;
            right: 0;
            // z-index: 10;
            text-align: center;
            background: #fff;
            }
              tr > th:nth-last-child(2),
            tr > td:nth-last-child(2) {
            position: sticky;
            position: -webkit-sticky;
            right: 1.5rem;
            // z-index: 10;
            text-align: center;
            background: #fff;
            }
         }
        }
    .van-checkbox{
        justify-content: center;
    }
    /deep/.van-checkbox__icon--checked .van-icon{
        background-color: #fd7e2d;
    border-color: #fd7e2d;
    }
}
.assets {
    .fixedH {
        height: calc(100vh - 3.6rem);
        overflow: scroll;
        .van-cell__title {
            flex: 1;
        }
    }
    .query {
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
        i {
            transform: translateY(0.03rem);
        }
    }
    .bottom {
        position: fixed;
        bottom: 0;
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
        i {
            transform: translateY(0.03rem);
        }
    }
}
.form4 {
    background-color: #fff;
    text-align: left;
    .picCard {
        /deep/.van-field__error-message {
            text-align: center;
        }
    }
    .errorLeft {
        /deep/.van-field__error-message {
            text-align: left;
        }
        /deep/.van-field {
            padding: 0;

            .van-field__body {
                display: none;
            }
        }
    }
    .field {
        position: relative;
    }
    .body {
        padding: 0.1rem;
        .van-uploader {
            // margin: 0.2rem;
            /deep/.van-uploader__preview-image {
                border: 1px solid #ebedf0;
            }
        }
        .picCard {
            display: inline-block;
            vertical-align: top;
            margin: 0.2rem;
            // width: 2.2rem;
            .text {
                text-align: center;
                .van-field {
                    padding: 0;
                    /deep/.van-field__label {
                        padding-left: 0.3rem;
                    }
                    /deep/input {
                        text-align: center;
                    }
                }
            }
            .textBorder {
                /deep/.van-field__body {
                    border: 1px solid $border-color;
                    border-radius: 0.1rem;
                    overflow: hidden;
                }
            }
        }
        .m-t {
            margin-top: 0.54rem;
        }
    }
    .body1 {
        padding: 0.3rem;
    }
}
.line {
    &::after {
        width: 100%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        left: 0;
        bottom: 0;
        border-bottom: 0.02667rem solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
}
/deep/.van-uploader__preview-image,
/deep/ .van-uploader__upload,
/deep/.van-uploader__file {
    width: 3rem;
    height: 3rem;
}
.video-player {
    height: 100%;
    /deep/ .video-js.vjs-fluid {
        height: 100%;
    }
}
/deep/.van-uploader__preview-delete {
    z-index: 999;
}
.videoP {
    position: fixed;
    background: rgb(0, 0, 0);
    z-index: 2000;
    .bg {
        position: relative;
        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
            z-index: 2001;
        }
        .close {
            position: absolute;
            right: 0.3rem;
            top: 0.3rem;
            border-radius: 1rem;
            width: 0.65rem;
            text-align: center;
            height: 0.65rem;
            line-height: 0.65rem;
            background: #dadada;
            z-index: 2002;
            i {
                font-size: 0.45rem;
                color: #000;
            }
        }
    }
}
 .construct_list {
    background: #fff;

    .top {
      padding: 0.26667rem 0.42667rem;
      position: relative;
    }
    .top::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0rem;
      bottom: 0;
      left: 0rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .top li {
      width: 18%;
      position: relative;
    }
    .top li:nth-of-type(1) {
      // width:30%;
      //  flex:1;
      text-align: left;
    }
    .list li {
      padding: 0.26667rem 0.42667rem;
      position: relative;
    }
    .list li:after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0rem;
      bottom: 0;
      left: 0rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .list li span {
      width: 18%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list li span:nth-of-type(1) {
      // width:30%;
      // flex:1;
      text-align: left;
    }
  }
</style>
